(function injectCartUXStyles() {
  const style = document.createElement("style");
  style.id = "alcami-cart-ux";
  style.textContent = `
details.cart-drawer-container.mini-cart--loading mini-cart > form { opacity: .35; pointer-events: none; transition: opacity .2s ease; }
details.cart-drawer-container mini-cart > form { transition: opacity .2s ease; }

/* ---- Alcami loader component (shared by drawer + page) ---- */
.acl-inner { display: flex; flex-direction: column; align-items: center; gap: 12px; }
.acl-glass { position: relative; width: 56px; height: 72px; border: 2.5px solid #211d17; border-top-width: 2px; border-radius: 9px 9px 22px 22px; background: rgba(255,255,255,.8); box-shadow: inset 0 0 0 4px rgba(255,255,255,.55); overflow: hidden; }
.acl-liquid { position: absolute; left: 5px; right: 5px; bottom: 4px; height: 18%; border-radius: 4px 4px 16px 16px; background: linear-gradient(180deg, #e6c9a0 0%, #c1905f 45%, #8a5f3a 100%); animation: acl-pour 2s ease-in-out infinite; }
.acl-foam { position: absolute; top: -7px; left: -2px; right: -2px; height: 11px; background: #f7f1e6; border-radius: 50% 50% 40% 40% / 90% 90% 30% 30%; box-shadow: 0 1px 0 rgba(33,29,23,.08); }
.acl-dust { position: absolute; top: -8px; width: 3px; height: 3px; border-radius: 50%; background: #c59d42; opacity: 0; }
.acl-dust.d1 { left: 42%; animation: acl-dust 1.35s ease-in .1s infinite; }
.acl-dust.d2 { left: 52%; animation: acl-dust 1.35s ease-in .55s infinite; }
.acl-dust.d3 { left: 47%; animation: acl-dust 1.35s ease-in .95s infinite; }
.acl-brand { font-family: var(--font-heading-family, "Spacetype - Garet Book", serif); font-size: 11px; font-weight: 600; letter-spacing: .42em; padding-left: .42em; color: #211d17; }
.acl-msg { font-family: var(--font-body-family, inherit); font-size: 13px; font-weight: 500; letter-spacing: .02em; color: #211d17; opacity: .85; }
.acl-msg::after { content: ""; display: inline-block; width: 1.1em; text-align: left; animation: acl-dots 1.2s steps(4, end) infinite; }
@keyframes acl-pour { 0% { height: 18%; } 55% { height: 76%; } 100% { height: 18%; } }
@keyframes acl-dust { 0% { opacity: 0; transform: translateY(0); } 15% { opacity: 1; } 85% { opacity: .9; } 100% { opacity: 0; transform: translateY(52px); } }
@keyframes acl-dots { 0% { content: ""; } 25% { content: "."; } 50% { content: ".."; } 75% { content: "..."; } 100% { content: ""; } }

/* ---- Drawer loader ---- */
.alcami-cart-loader { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; z-index: 40; background: rgba(250,247,242,.75); backdrop-filter: blur(2px); opacity: 0; transition: opacity .18s ease; pointer-events: none; }
.alcami-cart-loader.is-visible { opacity: 1; }
.alcami-cart-loader .acl-inner { transform: translateY(-6%); }

/* ---- Page loader: visibility keyed to the existing body class ---- */
.alcami-page-loader { position: fixed; inset: 0; display: flex; align-items: center; justify-content: center; z-index: 900; background: radial-gradient(circle at 50% 42%, rgba(250,247,242,.95) 0%, rgba(250,247,242,.8) 100%); backdrop-filter: blur(2px); opacity: 0; visibility: hidden; transition: opacity .18s ease, visibility .18s ease; pointer-events: none; }
body.updating-cart .alcami-page-loader { opacity: 1; visibility: visible; }

/* Retire the legacy circle spinner everywhere */
.sticky-offer.update_cart_row2:after,
.update_cart_row:after,
body.template-cart .update_cart_row:after,
body.template-cart.updating-cart .update_cart_row:after,
body.updating-cart .sticky-offer.update_cart_row2:after,
body.updating-cart .update_cart_row:after,
.alcami-kit-v3-inn.update_cart_row:after { display: none !important; }

@media (prefers-reduced-motion: reduce) {
  .acl-liquid, .acl-dust, .acl-msg::after { animation: none; }
  .acl-liquid { height: 60%; }
  .acl-dust { display: none; }
}`;
  document.head.appendChild(style);
})();

function alcamiLoaderMarkup() {
  return (
    '<div class="acl-inner">' +
      '<div class="acl-glass" aria-hidden="true">' +
        '<span class="acl-dust d1"></span><span class="acl-dust d2"></span><span class="acl-dust d3"></span>' +
        '<div class="acl-liquid"><span class="acl-foam"></span></div>' +
      '</div>' +
      '<div class="acl-brand" aria-hidden="true">ALCAMI</div>' +
      '<div class="acl-msg" role="status" aria-live="polite"></div>' +
    '</div>'
  );
}

(function mountPageLoader() {
  const mount = () => {
    if (document.querySelector(".alcami-page-loader")) return;
    const overlay = document.createElement("div");
    overlay.className = "alcami-page-loader";
    overlay.innerHTML = alcamiLoaderMarkup();
    overlay.querySelector(".acl-msg").textContent = "Brewing your ritual";
    document.body.appendChild(overlay);
  };
  if (document.body) mount();
  else document.addEventListener("DOMContentLoaded", mount);
})();

function openCartDrawers() {
  document.querySelectorAll("details.cart-drawer-container").forEach((drawer) => {
    drawer.setAttribute("open", "");
    drawer.classList.add("menu-opening");
  });
}

function setDrawerLoading(on, message) {
  document.querySelectorAll("details.cart-drawer-container").forEach((drawer) => {
    drawer.classList.toggle("mini-cart--loading", on);
    const panel = drawer.querySelector("mini-cart");
    if (!panel) return;

    let loader = panel.querySelector(".alcami-cart-loader");
    if (on) {
      if (!loader) {
        loader = document.createElement("div");
        loader.className = "alcami-cart-loader";
        loader.innerHTML = alcamiLoaderMarkup();
        panel.appendChild(loader);
      }
      const msgEl = loader.querySelector(".acl-msg");
      if (message) {
        msgEl.textContent = message;
      } else if (!msgEl.textContent) {
        msgEl.textContent = "Brewing your ritual";
      }
      requestAnimationFrame(() => loader.classList.add("is-visible"));
    } else if (loader) {
      loader.remove();
    }
  });

  const pageMsg = document.querySelector(".alcami-page-loader .acl-msg");
  if (pageMsg && message) pageMsg.textContent = message;
}

function isSalepifyGiftLine(item) {
  const p = item.properties;
  if (!p) return false;
  return Boolean(
    p["_salepify-advanced-fg"] ||
    p["_salepify_product_id"] ||
    p["_salepify-embed"] ||
    p["_salepify-bogo"] ||
    p["_alcami_gift"]
  );
}

// ---- Alcami native gift engine (engine + rules emitted by alcami-gift-config.liquid;
// pricing enforced by the matching automatic Buy X Get Y discount) ----
function nativeGiftEngineActive() {
  return window.ALCAMI_GIFT_ENGINE === "native" && Array.isArray(window.ALCAMI_GIFT_RULES) && window.ALCAMI_GIFT_RULES.length > 0;
}

window.__alcamiLastCart = null;

// Prime the cart snapshot as early as possible. computeGiftItems dedupes gift
// variants against this snapshot; when it is still null on the first add of a
// page view, a gift already sitting in the cart gets added a SECOND time. Those
// duplicate lines are what push the cart past the discount's free-item cap and
// leave real gifts sitting at full price.
(function primeAlcamiCartSnapshot() {
  if (window.__alcamiCartPrimed) return;
  window.__alcamiCartPrimed = true;
  fetch("/cart.js", { headers: { Accept: "application/json" } })
    .then(function (r) { return r.json(); })
    .then(function (c) { if (!window.__alcamiLastCart) window.__alcamiLastCart = c; })
    .catch(function () { /* dedupe falls back to reconcileGifts */ });
})();

// Given the items about to be added, return gift items to append to the SAME
// /cart/add.js request. lastCart (may be null/stale) suppresses duplicates;
// reconcileGifts clamps any that slip through.
function computeGiftItems(payloadItems) {
  if (!nativeGiftEngineActive()) return [];
  const gifts = [];
  const inCart = new Set(
    ((window.__alcamiLastCart && window.__alcamiLastCart.items) || [])
      .filter(function (i) { return i.properties && i.properties["_alcami_gift"]; })
      .map(function (i) { return String(i.variant_id); })
  );
  window.ALCAMI_GIFT_RULES.forEach(function (rule) {
    const triggered = payloadItems.some(function (item) {
      if (rule.trigger_variant_ids.map(String).indexOf(String(item.id)) === -1) return false;
      if (rule.require_subscription && !item.selling_plan) return false;
      return true;
    });
    if (!triggered) return;
    rule.gift_variant_ids.forEach(function (vid) {
      const key = String(vid);
      if (inCart.has(key)) return;
      if (gifts.some(function (g) { return String(g.id) === key; })) return;
      gifts.push({ id: vid, quantity: 1, properties: { "_alcami_gift": rule.title } });
    });
  });
  return gifts;
}

// Does the cart still contain a line satisfying a rule's trigger?
function ruleStillQualifies(rule, cart) {
  return (cart.items || []).some(function (i) {
    if (i.properties && i.properties["_alcami_gift"]) return false;
    if (rule.trigger_variant_ids.map(String).indexOf(String(i.variant_id)) === -1) return false;
    if (rule.require_subscription && !i.selling_plan_allocation && !i.selling_plan) return false;
    return true;
  });
}

let reconcilingGifts = false;
async function reconcileGifts(cart) {
  if (reconcilingGifts) return cart;
  try {
    if (!cart) {
      cart = await fetch("/cart.js").then((res) => res.json());
    }
    window.__alcamiLastCart = cart;
    if (!cart.items || !cart.items.length) return cart;

    const giftLines = cart.items.filter(isSalepifyGiftLine);
    const realLines = cart.items.length - giftLines.length;

    // Orphan case: cart contains ONLY app-marked gift lines. Individually
    // purchased copies of the same products never carry _salepify properties,
    // so they are never touched.
    if (giftLines.length && realLines === 0) {
      reconcilingGifts = true;
      const updates = {};
      giftLines.forEach((item) => { updates[item.key] = 0; });
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates })
      });
      cart = await fetch("/cart.js").then((res) => res.json());
      if (document.body.classList.contains("template-cart")) {
        window.location.reload();
        return cart;
      }
      await renderMiniCart(cart);
    }
    // Native engine: remove _alcami_gift lines whose rule no longer qualifies
    // (trigger removed / subscription dropped) and clamp gift quantities to 1.
    if (nativeGiftEngineActive()) {
      const updates = {};
      const seenGiftVariants = {};
      cart.items.forEach((item) => {
        const ruleTitle = item.properties && item.properties["_alcami_gift"];
        if (!ruleTitle) return;
        const rule = window.ALCAMI_GIFT_RULES.find((r) => r.title === ruleTitle);
        if (!rule || !ruleStillQualifies(rule, cart)) {
          updates[item.key] = 0;
          return;
        }
        // One gift line per variant, whichever rule put it there. Overlapping
        // rules (the triple bundle and the double both grant the welcome kit)
        // would otherwise stack duplicate lines that no discount can cover.
        const vid = String(item.variant_id);
        if (seenGiftVariants[vid]) {
          updates[item.key] = 0;
          return;
        }
        seenGiftVariants[vid] = true;
        if (item.quantity > 1) {
          updates[item.key] = 1;
        }
      });
      if (Object.keys(updates).length) {
        reconcilingGifts = true;
        const updated = await fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(Object.assign({ updates }, CART_SECTIONS_PAYLOAD))
        }).then((r) => r.json());
        const html = sectionFromResponse(updated);
        window.__alcamiLastCart = updated;
        if (document.body.classList.contains("template-cart")) {
          window.location.reload();
          return updated;
        }
        if (html) {
          await applyMiniCart(updated, html);
        } else {
          await renderMiniCart(updated);
        }
        cart = updated;
      }
    }

    // Price verification. The theme promises these lines are free; the automatic
    // Buy X Get Y discount is what actually makes them free. A gift that comes
    // back priced is reported, and the mini-cart shows a Remove button for it so
    // the customer is never stuck with a charge they cannot clear. It is NOT
    // deleted automatically: a temporary cap overrun would otherwise wipe gifts
    // the customer legitimately earned.
    if (nativeGiftEngineActive()) {
      const pricedGifts = (cart.items || []).filter(function (item) {
        if (!(item.properties && item.properties["_alcami_gift"])) return false;
        const finalLine = typeof item.final_line_price === "number" ? item.final_line_price : item.line_price;
        return finalLine > 0;
      });
      if (pricedGifts.length) {
        console.error(
          "[alcami-gift] " + pricedGifts.length + " gift line(s) are not discounted: " +
          pricedGifts.map(function (i) { return i.title; }).join(", ") +
          ". Check that one automatic Buy X Get Y discount covers every gift this rule grants, and that its free-item quantity is at least the number of gifts."
        );
      }
    }

    // Salepify engine: let the app re-evaluate its rules (adds missing gifts with
    // the app's own pricing, removes partial orphans per its rule map).
    if (!nativeGiftEngineActive() && window.tlFreeGiftOffer && typeof window.tlFreeGiftOffer.updateCartData === "function") {
      window.tlFreeGiftOffer.updateCartData();
    }
  } catch (err) {
    console.error("Gift reconcile error:", err);
  } finally {
    reconcilingGifts = false;
  }
  return cart;
}

function renderCartBubbles(cartOrCount) {
  const count = typeof cartOrCount === "number" ? cartOrCount : (cartOrCount && cartOrCount.item_count) || 0;
  document.querySelectorAll("#cart-icon-bubble").forEach((host) => {
    let bubble = host.querySelector(".cart-count-bubble");
    // header.liquid only renders the bubble when the cart was non-empty at page
    // load, so create it on demand for empty-cart landings.
    if (!bubble) {
      if (count <= 0) return;
      bubble = document.createElement("span");
      bubble.className = "cart-count-bubble";
      host.appendChild(bubble);
    }
    if (count > 0) {
      bubble.classList.remove("hidden");
      if (count >= 100) {
        bubble.classList.add("cart-count-bubble--dot");
        bubble.innerHTML = "";
      } else {
        bubble.classList.remove("cart-count-bubble--dot");
        bubble.innerHTML = `<span aria-hidden="true">${count}</span>`;
      }
    } else {
      bubble.classList.add("hidden");
      bubble.innerHTML = "";
    }
  });
}

// Shopify Ajax API: return the rendered drawer inside the mutation response
// so the drawer updates in ONE round trip instead of a follow-up fetch.
const CART_SECTIONS_PAYLOAD = { sections: "mini-cart", sections_url: "/cart" };

// Init a slick slider only when the element exists with slides, and never let
// a slick-internal error (e.g. initADA on an empty list) kill the ready chain.
function safeSlickInit($el, opts) {
  if (!$el || !$el.length || !$el.children().length) return;
  if ($el.hasClass("slick-initialized")) return;
  try {
    $el.slick(opts);
  } catch (e) {
    console.error("Slick init skipped:", e);
  }
}
function sectionFromResponse(data) {
  return (data && data.sections && data.sections["mini-cart"]) || null;
}

function applyMiniCart(cart, miniCartText) {
  const miniCartForm = new DOMParser().parseFromString(miniCartText, "text/html").querySelector("form.mini-cart");
  return Promise.resolve().then(() => {
    if (miniCartForm) {
      document.querySelectorAll("details.cart-drawer-container mini-cart").forEach((drawerMiniCart) => {
        drawerMiniCart.innerHTML = "";
        drawerMiniCart.appendChild(miniCartForm.cloneNode(true));
      });
    }
    if (cart) {
      window.__alcamiLastCart = cart;
      renderCartBubbles(cart);
    } else if (miniCartForm) {
      const attrCount = parseInt(miniCartForm.getAttribute("data-cart-item-count"), 10);
      if (!isNaN(attrCount)) renderCartBubbles(attrCount);
    }
    setDrawerLoading(false);
    requestAnimationFrame(() => {
      const $announceList = $(".cart_drawer_announcements .cart_drawer_announce_list");
      if ($announceList.length) {
        if ($announceList.hasClass("slick-initialized")) {
          $announceList.slick("unslick");
        }
        $announceList.slick({
          dots: false,
          arrows: false,
          infinite: true,
          speed: 700,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 1000,
          fade: true,
          cssEase: "linear"
        });
        $announceList.slick("setPosition");
      }
    });
  });
}

async function renderMiniCart(cart) {
  const miniCartText = await fetch(`/cart?section_id=mini-cart&_=${Date.now()}`).then((res) => res.text());
  await applyMiniCart(cart, miniCartText);
}

function refreshRecommendations(addedProductId) {
  if (!addedProductId || !document.querySelector("cart-recommendations")) return;
  const recUrl = `/recommendations/products?section_id=mini-cart&limit=4&product_id=${addedProductId}`;
  fetch(recUrl)
    .then((res) => res.text())
    .then((recHTML) => {
      const newRecommendations = new DOMParser().parseFromString(recHTML, "text/html").querySelector("cart-recommendations");
      const current = document.querySelector("cart-recommendations");
      if (newRecommendations && current) current.replaceWith(newRecommendations);
    })
    .catch((err) => console.error("Recommendations error:", err));
}

async function refreshMiniCart(options = {}) {
  const { openDrawer = false, addedProductId = null, knownCart = null, loadingMessage = null } = options;

  if (openDrawer) {
    openCartDrawers();
    setDrawerLoading(true, loadingMessage);
  }

  try {
    const [cart, miniCartText] = await Promise.all([
      knownCart ? Promise.resolve(knownCart) : fetch("/cart.js").then((res) => res.json()),
      fetch(`/cart?section_id=mini-cart&_=${Date.now()}`).then((res) => res.text())
    ]);
    await applyMiniCart(cart, miniCartText);

    refreshRecommendations(addedProductId);
    reconcileGifts(cart);

    return cart;
  } finally {
    setDrawerLoading(false);
  }
}

// Bridge for the Salepify free-gift override: its updateCartData calls a global
// refreshCart() after auto-adding gifts, which only exists on the landing page.
// Point it at our drawer refresh so the gift appears the moment the app finishes.
if (typeof window.refreshCart === "undefined") {
  window.refreshCart = function () {
    return refreshMiniCart({});
  };
}

// Upsell Add buttons (global.js AddToCart element run their own pipeline;
// wrap it with the branded loader via its lifecycle events).
let upsellLoaderTimer = null;
document.addEventListener("click", (e) => {
  const upsellBtn = e.target && e.target.closest && e.target.closest("add-to-cart.mini-cart-atc");
  if (!upsellBtn || upsellBtn.hasAttribute("disabled")) return;
  setDrawerLoading(true, "Brewing your ritual");
  clearTimeout(upsellLoaderTimer);
  upsellLoaderTimer = setTimeout(() => setDrawerLoading(false), 8000);
}, true);

["ajaxProduct:added", "ajaxProduct:error"].forEach((evtName) => {
  document.addEventListener(evtName, () => {
    clearTimeout(upsellLoaderTimer);
    setDrawerLoading(false);
    if (evtName === "ajaxProduct:added") reconcileGifts();
  });
});

document.addEventListener("toggle", (e) => {
  const drawer = e.target;
  if (drawer && drawer.matches && drawer.matches("details.cart-drawer-container") && drawer.open) {
    reconcileGifts();
  }
}, true);

// ---- Cart interception (registered at parse time, resilient to section errors) ----
document.addEventListener("click", async function (e) {
  const el = e.target.closest('a[href*="/cart/add"]');
  if (!el) return;

  const href = el.getAttribute("href");
  if (!href) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const productsPage = el.closest(".products-page");
  const stickybtn = el.closest(".sticky-offer");
  const flvbox = el.closest(".choose-flavour-area");
  document.body.classList.add("updating-cart");
  if (productsPage) productsPage.classList.add("update_cart_row");
  if (stickybtn) stickybtn.classList.add("update_cart_row2");
  if (flvbox) flvbox.classList.add("update_cart_row");

  // Instant feedback: open the drawer with the loader before the network request.
  openCartDrawers();
  setDrawerLoading(true, "Brewing your ritual");

  try {
    const url = new URL(href, window.location.origin);
    const multiIds = url.searchParams.getAll("id[]");
    let payload;

    let payloadItems;
    if (multiIds.length) {
      payloadItems = multiIds.map((vid) => ({ id: vid, quantity: 1 }));
    } else {
      const id = url.searchParams.get("id");
      if (!id) throw new Error("No variant id in cart link");
      const quantity = url.searchParams.get("quantity") || 1;
      const selling_plan = url.searchParams.get("selling_plan");
      const item = { id, quantity };
      if (selling_plan) item.selling_plan = selling_plan;
      payloadItems = [item];
    }
    // Native gift engine: gifts ride in the SAME request - no cascade.
    // Gifts go FIRST in the array: Shopify stacks later items higher, so the
    // main product renders above its gifts in the drawer.
    payloadItems = computeGiftItems(payloadItems).concat(payloadItems);
    payload = Object.assign({ items: payloadItems }, CART_SECTIONS_PAYLOAD);

    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    if (!addResponse.ok) throw new Error("Add to cart failed");
    const addData = await addResponse.json();
    const addedProductId = addData.product_id || (addData.items && addData.items[0] && addData.items[0].product_id);
    const sectionHTML = sectionFromResponse(addData);

    if (sectionHTML) {
      // Drawer rendered from the add response itself: one round trip total.
      await applyMiniCart(null, sectionHTML);
      refreshRecommendations(addedProductId);
      // Background: authoritative cart state for the bubble + gift reconciler.
      fetch("/cart.js").then((r) => r.json()).then((cart) => {
        renderCartBubbles(cart);
        reconcileGifts(cart);
      }).catch(() => {});
    } else {
      await refreshMiniCart({ openDrawer: true, addedProductId });
    }
  } catch (err) {
    console.error("Cart update error:", err);
    setDrawerLoading(false);
  } finally {
    document.body.classList.remove("updating-cart");
    if (productsPage) productsPage.classList.remove("update_cart_row");
    if (stickybtn) stickybtn.classList.remove("update_cart_row2");
    if (flvbox) flvbox.classList.remove("update_cart_row");
  }
  document.body.classList.add("mini-cart--open");
});

document.addEventListener("submit", async function (e) {
  const form = e.target.closest("form[action*='/cart/add']");
  if (!form) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const productsPage = form.closest(".products-page");
  document.body.classList.add("updating-cart");
  if (productsPage) productsPage.classList.add("update_cart_row");

  // Instant feedback: open the drawer with the loader before the network request.
  openCartDrawers();
  setDrawerLoading(true, "Brewing your ritual");

  try {
    const formData = new FormData(form);

    const formItem = {
      id: formData.get("id"),
      quantity: formData.get("quantity") || 1,
    };
    const selling_plan = formData.get("selling_plan");
    if (selling_plan) formItem.selling_plan = selling_plan;
    const formItems = computeGiftItems([formItem]).concat([formItem]);
    const payload = Object.assign({ items: formItems }, CART_SECTIONS_PAYLOAD);

    const addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    });

    const addData = await addResponse.json();
    const addedProductId = addData.product_id || (addData.items && addData.items[0] && addData.items[0].product_id);
    const sectionHTML = sectionFromResponse(addData);

    if (sectionHTML) {
      await applyMiniCart(null, sectionHTML);
      refreshRecommendations(addedProductId);
      fetch("/cart.js").then((r) => r.json()).then((cart) => {
        renderCartBubbles(cart);
        reconcileGifts(cart);
      }).catch(() => {});
    } else {
      await refreshMiniCart({ openDrawer: true, addedProductId });
    }
  } catch (err) {
    console.error("Cart update error:", err);
    setDrawerLoading(false);
  } finally {
    document.body.classList.remove("updating-cart");
    if (productsPage) productsPage.classList.remove("update_cart_row");
  }
});

document.addEventListener("click", async function (e) {
  const el = e.target.closest("a.delete-product");
  if (!el) return;

  const href = el.getAttribute("href");
  if (!href) return;

  const url = new URL(href, window.location.origin);
  if (!url.pathname.includes("/cart/change")) return;

  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  setDrawerLoading(true, "Updating your ritual");

  try {
    const id = url.searchParams.get("id");
    const quantity = url.searchParams.get("quantity") || 0;

    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(Object.assign({ id, quantity }, CART_SECTIONS_PAYLOAD)),
    });

    let cart = await res.json();
    let sectionHTML = sectionFromResponse(cart);

    // Predictive orphan cleanup: if this removal leaves only gift lines,
    // clear them in the same pass so the drawer re-renders once, fully settled.
    const giftLines = (cart.items || []).filter(isSalepifyGiftLine);
    if (giftLines.length && giftLines.length === cart.items.length) {
      const updates = {};
      giftLines.forEach((item) => { updates[item.key] = 0; });
      cart = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(Object.assign({ updates }, CART_SECTIONS_PAYLOAD))
      }).then((r) => r.json());
      sectionHTML = sectionFromResponse(cart);
    }

    if (sectionHTML) {
      // change/update responses carry both the cart AND the rendered drawer.
      openCartDrawers();
      await applyMiniCart(cart, sectionHTML);
      reconcileGifts(cart);
    } else {
      await refreshMiniCart({ openDrawer: true, knownCart: cart });
    }
  } catch (err) {
    console.error("Remove error:", err);
    setDrawerLoading(false);
  }
}, true);

document.addEventListener("change", async function (e) {
  const select = e.target.closest(".mini-cart__navigation .custom-select");
  if (!select) return;

  const li = select.closest("li[data-variant-id]");
  if (!li) return;
  const variantId = li.getAttribute("data-variant-id");
  const quantity = parseInt(select.value, 10);
  document.body.classList.add("updating-cart");
  setDrawerLoading(true, "Updating your ritual");

  try {
    const cart = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(Object.assign({
        id: variantId,
        quantity: quantity,
      }, CART_SECTIONS_PAYLOAD)),
    }).then((r) => r.json());

    const sectionHTML = sectionFromResponse(cart);
    if (sectionHTML) {
      openCartDrawers();
      await applyMiniCart(cart, sectionHTML);
      reconcileGifts(cart);
    } else {
      await refreshMiniCart({ openDrawer: true, loadingMessage: "Updating your ritual" });
    }
  } catch (err) {
    console.error("Quantity update error:", err);
    setDrawerLoading(false);
  } finally {
    document.body.classList.remove("updating-cart");
  }
});


// Non-product pages must not carry a ?variant param; strip stale ones left by
// older sessions so reloads start from a clean state.
document.addEventListener("DOMContentLoaded", () => {
  if (!document.body.classList.contains("template-product")) {
    const cleanUrl = new URL(window.location.href);
    if (cleanUrl.searchParams.has("variant")) {
      cleanUrl.searchParams.delete("variant");
      window.history.replaceState({}, "", cleanUrl.toString());
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  if (document.body.classList.contains("template-cart")) {
    let nudges = 0;
    const nudge = setInterval(() => {
      nudges++;
      if (window.tlFreeGiftOffer && typeof window.tlFreeGiftOffer.updateCartData === "function") {
        clearInterval(nudge);
        reconcileGifts();
      } else if (nudges >= 20) {
        clearInterval(nudge);
        reconcileGifts();
      }
    }, 250);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  document.documentElement.classList.add('custom-js-ready');
  document.querySelectorAll('a[href*="/cart/add"]').forEach(function(link){
    link.style.pointerEvents = '';
  });
  const reviewSummary = document.querySelector('.review-section');
  const reviewSummary2 = document.querySelector('.review-section.mobile.mobile-reviews');
  const reviewWidget = document.querySelector('#judgeme_product_reviews');

  $(document).on("click",".mix_match_open_drawer", function () {
    $("body").addClass("mix_match_open");
  });

  $(document).on("click",".close_mix_match", function () {
    $("body").removeClass("mix_match_open");
  });
  
  if (reviewSummary && reviewWidget) {
    reviewSummary.addEventListener('click', function(e) {
      e.preventDefault();
      reviewWidget.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
      });
    });
  }

  if (reviewSummary2 && reviewWidget) {
    reviewSummary2.addEventListener('click', function(e) {
      e.preventDefault();
      reviewWidget.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
      });
    });
  }

  $(document).on("click", "#menu-drawer .disclosure__button.localization-form__select", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const isExpanded = $btn.attr("aria-expanded") === "true";
    $btn.attr("aria-expanded", !isExpanded);
    const $countryList = $btn.closest(".localization-form").find("#HeaderDrawerCountryList");

    if ($countryList.attr("hidden")) {
      $countryList.removeAttr("hidden");
      $("body").addClass("country-list-open");
    } else {
      $countryList.attr("hidden", true);
      $("body").removeClass("country-list-open");
    }
  });

  $(document).on("click", "#menu-drawer .disclosure__button.localization-form__select", function (e) {
    e.preventDefault();
    const $btn = $(this);
    const isExpanded = $btn.attr("aria-expanded") === "true";
    $btn.attr("aria-expanded", !isExpanded);
    const $langList = $btn.closest(".localization-form").find("#HeaderDrawerLanguageList");

    if ($langList.attr("hidden")) {
      $langList.removeAttr("hidden");
      $("body").addClass("country-list-open");
    } else {
      $langList.attr("hidden", true);
      $("body").removeClass("country-list-open");
    }
  });

  $(document).on("click", "#HeaderLanguageList a", function (e) {
    e.preventDefault();
    const selectedValue = $(this).data("value");
    const $input = $('input[type="hidden"][name="locale_code"]');
    $input.val(selectedValue);
    $input.closest("form").submit();
  });

  $(document).on("click", "#HeaderCountryList a", function (e) {
    e.preventDefault();
    const selectedValue = $(this).data("value");
    const $input = $('input[type="hidden"][name="country_code"]');
    $input.val(selectedValue);
    $input.closest("form").submit();
  });

  $(document).on("click", "#HeaderDrawerCountryList a", function (e) {
    e.preventDefault();
    const selectedValue = $(this).data("value");
    const $input = $('input[type="hidden"][name="country_code"]');
    $input.val(selectedValue);
    $input.closest("form").submit();
  });

  $(document).on("click", "#HeaderDrawerLanguageList a", function (e) {
    e.preventDefault();
    const selectedValue = $(this).data("value");
    const $input = $('input[type="hidden"][name="locale_code"]');
    $input.val(selectedValue);
    $input.closest("form").submit();
  });

  var timerSection = document.querySelector(".alcami-timer-sec");
  if (timerSection) {
    document.body.classList.remove("no-timer");
    document.body.classList.add("has-timer");
    var timerData = timerSection.querySelector(".alcami-timer-m");
    if (timerData) {
      var timerValue = parseInt(timerData.dataset.timerValue) || 15;
      var timerUnit = timerData.dataset.timerUnit || "minutes";
      var durationInSeconds;

      switch (timerUnit) {
        case "days":
          durationInSeconds = timerValue * 24 * 60 * 60;
          break;
        case "hours":
          durationInSeconds = timerValue * 60 * 60;
          break;
        case "minutes":
          durationInSeconds = timerValue * 60;
          break;
        case "seconds":
        default:
          durationInSeconds = timerValue;
      }

      var TIMER_END_KEY = "alcami_timer_end";
      var TIMER_HIDE_UNTIL_KEY = "alcami_timer_hide_until";

      var now = Date.now();
      var hideUntil = localStorage.getItem(TIMER_HIDE_UNTIL_KEY);

      if (hideUntil && now < parseInt(hideUntil)) {
        timerSection.remove();
          document.body.classList.add("no-timer");
          document.body.classList.remove("has-timer");
      } else {
        var savedEndTime = localStorage.getItem(TIMER_END_KEY);
        var endTime;
        if (savedEndTime) {
          endTime = parseInt(savedEndTime);
        } else {
          endTime = now + (durationInSeconds * 1000);
          localStorage.setItem(TIMER_END_KEY, endTime);
        }

        var daysEl = timerSection.querySelector("#alcami-days");
        var hoursEl = timerSection.querySelector("#alcami-hours");
        var minutesEl = timerSection.querySelector("#alcami-minutes");
        var secondsEl = timerSection.querySelector("#alcami-seconds");

        var timer = setInterval(function () {
          var remaining = Math.floor((endTime - Date.now()) / 1000);

          if (remaining <= 0) {
            clearInterval(timer);
            var fourHoursLater = Date.now() + (10 * 60 * 1000);
            localStorage.setItem(TIMER_HIDE_UNTIL_KEY, fourHoursLater);
            localStorage.removeItem(TIMER_END_KEY);
            timerSection.remove();
              document.body.classList.add("no-timer");
              document.body.classList.remove("has-timer");
            return;
          }

          var days = Math.floor(remaining / (60 * 60 * 24));
          var hours = Math.floor((remaining % (60 * 60 * 24)) / (60 * 60));
          var minutes = Math.floor((remaining % (60 * 60)) / 60);
          var seconds = remaining % 60;

          if (daysEl) daysEl.textContent = String(days).padStart(2, "0");
          if (hoursEl) hoursEl.textContent = String(hours).padStart(2, "0");
          if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, "0");
          if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, "0");

        }, 1000);
      }
    }

  } else {
    document.body.classList.remove("no-timer");
    document.body.classList.add("has-timer");
  }

  $(".alcami-featured-list.alcami-pdp-featured-list").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    variableWidth: true,
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: false
  });

  $('.alcami-featured-list.alcami-featured-slider').slick({
    mobileFirst: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    speed: 900,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  });

  $(".alcami-ingredients-sec .alcami-ingredients-list-slider").slick({
    dots: false,
    arrows: true,
    infinite: true,
    nextArrow: '<div class="next_arrow_slick alcami-ingredient-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-ingredient-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    speed: 800,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2500
        }
      }
    ]
  });

  var $slider = jQuery('.alcami-slideshow-list');

  $slider.on('init', function () {
    $('.title-carousel').each(function () {
      if (!$(this).hasClass('slick-initialized')) {
        $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: true,
          verticalSwiping: true,
          arrows: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
          speed: 1500,
          infinite: true,
          cssEase: 'cubic-bezier(.4,0,.2,1)',
          draggable: false,
          swipe: false,
          touchMove: false
        });
      }
    });
  });

  $slider.slick({
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-slideshow-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-slideshow-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    dots: false,
    infinite: true,
    slidesToShow: 1,
    speed: 700,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          adaptiveHeight: true, 
          arrows: false
        }
      }
    ]
  });

  $('.alcami-slideshow-list').on('init afterChange', function (event, slick, currentSlide) {
    var index = currentSlide || 0;
    var $slider = $(this);
    var isMobile = window.innerWidth < 750;

    $('.title-carousel').slick('setPosition');

    $slider.find('video').each(function () {
      this.pause();
      this.currentTime = 0;
    });

    var $currentSlide = $slider.find('.slick-slide[data-slick-index="' + index + '"]');
    var $video = $currentSlide.find('video');

    if ($video.length) {
      $video.prop('muted', true);
      if (!isMobile) {
        $video.get(0).play();
      }
    }

  });

  var isMouseInsideSlider = false;
  var currentPlayingVideo = null;

  $(".us-vs-them-btn a").on("click", function (ev) {
    ev.preventDefault();
    const pdpUrl = $(this).attr("data-pdp");
    if (!pdpUrl) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
      return;
    }

    const selectors = [
      ".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver",
      ".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver"
    ];

    selectors.forEach((sectionSelector) => {
      const section = document.querySelector(sectionSelector);
      if (!section) return;

      const teaItem = section.querySelector(
        `[data-pdp-url="${pdpUrl}"]`
      );

      if (!teaItem) return;

      // Remove active class from all items
      section.querySelectorAll(".new-layout-tea-item.active-tea-item").forEach((item) => {
          item.classList.remove("active-tea-item");
      });

      teaItem.click();
      const targetBox = section.querySelector(".new_layout_box");

      if (targetBox) {
        targetBox.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }

      // Click + button once
      const plusBtn =
        teaItem.querySelector(".qty-plus") ||
        teaItem.querySelector(".plus-btn") ||
        teaItem.querySelector(".plus-tea") ||
        teaItem.querySelector("[data-qty-plus]");

      if (plusBtn) {
        plusBtn.click();
      }
    });
  });

  $(window).scroll(function(){
    if ($(this).scrollTop() > 50) {
      $('.store-header').addClass('sticky');
    } else {
      $('.store-header').removeClass('sticky');
    }
  });

  function initMobileSlickSliders() {
    const isMobile = window.innerWidth < 749;
    const sliders = [
      {
        selector: '.supplements-lp24-list',
        settings: {
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          infinite: false
        }
      },
      {
        selector: '.dcx-shilajit__grid',
        settings: {
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          infinite: true
        }
      },
      {
        selector: '.dcx-colostrum__grid',
        settings: {
          slidesToScroll: 1,
          dots: true,
          arrows: false,
          slidesToShow: 1,
          infinite: true
        }
      }
    ];
    sliders.forEach(function(sliderData){
      const slider = $(sliderData.selector);
      if (!slider.length) return;
      if (isMobile) {
        if (!slider.hasClass('slick-initialized')) {
          requestAnimationFrame(function(){
            slider.slick(sliderData.settings);
          });
        }
      } else {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
      }
    });
  }

  initMobileSlickSliders();

  $('.main-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.thumbnail-gallery',
    focusOnSelect: true,
    infinite: false
  });

  $('.main-gallery').slick('setPosition');

  // Initialize thumbnail gallery
  $('.thumbnail-gallery').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.main-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.main-gallery-mix').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    asNavFor: '.thumbnail-gallery-mix',
    focusOnSelect: true,
    infinite: false
  });

  $('.main-gallery-mix').slick('setPosition');

  // Initialize thumbnail gallery
  $('.thumbnail-gallery-mix').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.main-gallery-mix',
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.thumbnail-gallery').on('click', '.tumb_img img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.main-gallery').slick('slickGoTo', index);
  });

  $('.thumbnail-gallery-mix').on('click', '.tumb_img img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.main-gallery-mix').slick('slickGoTo', index);
  });

  $('.kit-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.kit-thumbnail-gallery',
    focusOnSelect: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true
        }
      }
    ]
  });

  // Initialize thumbnail gallery
  $('.kit-thumbnail-gallery').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.kit-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('.kit-thumbnail-gallery').on('click', 'img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.kit-gallery').slick('slickGoTo', index);
  });

  $('.alcami-ritual-products-list').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    centerMode: true,
    centerPadding: '30px',
    responsive: [
      {
        breakpoint: 749,
        settings: "unslick"
      }
    ]
  });

  $('.alcami-leaders-list').slick({
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: true,
      responsive: [
        {
          breakpoint: 768,
          settings: "unslick"
        }
      ]
    });

    $(".alcami-before-after-list").slick({
      dots: false,
      arrows: true,
      nextArrow: '<div class="next_arrow_slick alcami-before-after-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
      prevArrow: '<div class="prev_arrow_slick alcami-before-after-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
      infinite: true,
      speed: 300,
      draggable: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            arrows: false
          }
        }
      ]
    });

  $(".alcami-testimonials-sec .alcami-testimonials-list").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    speed: 10000,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    variableWidth: true,
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    draggable: false,
    swipe: false,
    touchMove: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          variableWidth: false
        }
      }
    ]
  });

  $('.unique-perks-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  function updateHeroPrice() {
    const $checked = $('.hero_input_list input[type="radio"]:checked');
    if (!$checked.length) return;

    const checkedId = $checked.attr('id');
    const servings = checkedId.match(/\d+/)?.[0];

    $('.hero_flavor_container.subs_hero_flavor_container').removeClass('active');
    $('.try-once-btn').removeClass('is-active').hide();
    $('.hero_prices_span').hide();
    $(".single_cup_price").hide();
    $('.single_hero_btn').removeClass('is_active_hero').hide();

    if (!servings) return;

    const flavorIndex = (parseInt(servings, 10) / 30) - 1;
    $('.hero_flavor_container.subs_hero_flavor_container')
        .eq(flavorIndex).addClass('active');
    $(`.try-once-btn[data-servings="${servings}"]`).show().addClass('is-active');

    const $activeBtn = $(`.single_hero_btn[data-servings="${servings}"]`);
    $activeBtn.show().addClass('is_active_hero');

    $('#' + $checked.val() + '_price').show();
    $('#' + $checked.val() + '_cup').show();
  }

  updateHeroPrice();
  $('.hero_input_list input[type="radio"]').on('change', updateHeroPrice);

  const $marquee = $('.alcami-video-swiper .alcami-videos-slider');
  if ($marquee.length && !$marquee.hasClass('slick-initialized')) {
    $marquee.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 14000,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      swipe: false,
      draggable: false,
      touchMove: false,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 3 } }
      ]
    });
  }

  function marqueePause() {
    if ($marquee.length && $marquee.hasClass('slick-initialized')) $marquee.slick('slickPause');
  }
  function marqueePlay() {
    if ($marquee.length && $marquee.hasClass('slick-initialized')) $marquee.slick('slickPlay');
  }
  function marqueeTouch(enabled) {
    if (!$marquee.length || !$marquee.hasClass('slick-initialized')) return;
    $marquee.slick('slickSetOption', 'swipe', enabled, false);
    $marquee.slick('slickSetOption', 'draggable', enabled, false);
    $marquee.slick('slickSetOption', 'touchMove', enabled, false);
  }

  $('.alcami-video-swiper').on('mouseenter', function () {
    isMouseInsideSlider = true;
    marqueePause();
  }).on('mouseleave', function () {
    isMouseInsideSlider = false;
    resumeMarqueeIfAllowed();
  });

  function resumeMarqueeIfAllowed() {
    if (!isMouseInsideSlider && !currentPlayingVideo) {
      marqueeTouch(true);
      marqueePlay();
    }
  }

  $('.tiktok-video-embed .video-play svg, .tiktok-video-embed .video-play svg path').on('click', function () {
    const $videoItem = $(this).closest('.tiktok-video-item');
    const videoEl = $videoItem.find('video')[0];
    const $poster = $videoItem.find('.video-poster');

    if (currentPlayingVideo && currentPlayingVideo !== videoEl) {
      const $oldItem = $(currentPlayingVideo).closest('.tiktok-video-item');
      $oldItem.find('.video-poster').show();
      currentPlayingVideo.pause();
      $oldItem.addClass('video-hidden play-video-act').removeClass('pause-video-act ended_video');
    }

    marqueePause();
    marqueeTouch(false);

    if (!$poster.attr('src')) {
      $poster.attr('src', $(videoEl).attr('poster'));
    }

    $poster.hide();
    $videoItem.removeClass('video-hidden');

    if (videoEl.paused) {
      videoEl.play();
      $videoItem.addClass('pause-video-act').removeClass('play-video-act ended_video');
      currentPlayingVideo = videoEl;
    }
  });

  $('.tiktok-video-embed .video-pause svg, .tiktok-video-embed .video-pause svg path').on('click', function () {
    const $videoItem = $(this).closest('.tiktok-video-item');
    const videoEl = $videoItem.find('video')[0];
    const $poster = $videoItem.find('.video-poster');

    if (!videoEl.paused) {
      videoEl.pause();
      $poster.show();
      $videoItem.addClass('video-hidden play-video-act').removeClass('pause-video-act ended_video');
      currentPlayingVideo = null;
    }

    resumeMarqueeIfAllowed();
  });

  $('.tiktok-video-embed video').on('ended', function () {
    const $videoItem = $(this).closest('.tiktok-video-item');
    const $poster = $videoItem.find('.video-poster');
    this.currentTime = 0;
    $poster.show();
    $videoItem.addClass('ended_video video-hidden').removeClass('play-video-act pause-video-act');
    currentPlayingVideo = null;
    resumeMarqueeIfAllowed();
  });

  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('mini-cart-variant-select')) return;

    const select = e.target;
    const variantId = select.value;

    const container = select.closest('li');
    const btn = container.querySelector('.mini-cart-atc');

    if (btn) {
      btn.setAttribute('data-variant-id', variantId);
    }
  });

  safeSlickInit($(".cart_drawer_announcements .cart_drawer_announce_list"), {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    fade: true,
    cssEase: 'linear'
  });

  safeSlickInit($(".cart-recommendations-cart-drawer .mini-cart__navigation"), {
    dots: false,
    arrows: true,
    appendArrows: '.cart-rec-arrows',
    infinite: false,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1
  });

  var $announceSlider = $('.cart_drawer_announcements .cart_drawer_announce_list');
  if ($announceSlider.hasClass('slick-initialized')) $announceSlider.slick('setPosition');

  var lang = document.documentElement.lang;
  if (lang && lang !== 'en') {

    $('a[href]').each(function () {
      var $link = $(this);
      var href = $link.attr('href');
      if (!href) return;
      if (
        href.startsWith('#') ||
        href.startsWith('mailto:') ||
        href.startsWith('tel:') ||
        href.startsWith('javascript:')
      ) {
        return;
      }

      try {
        var url = new URL(href, window.location.origin);
        if (url.hostname !== window.location.hostname) return;
        if (
          url.pathname === '/' + lang ||
          url.pathname.startsWith('/' + lang + '/')
        ) {
          return;
        }
        if (!url.pathname.startsWith('/')) {
          url.pathname = '/' + url.pathname;
        }
        url.pathname = '/' + lang + url.pathname;
        $link.attr('href', url.toString());
      } catch (e) {
        console.warn('Invalid URL:', href);
      }
    });
  }

  const targetSelector = "#shopify-section-template--21620728398039__177122591210dd36ae";

  function scrollToReviews() {
    const target = document.querySelector(targetSelector);
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });

      history.replaceState(null, null, window.location.pathname + window.location.search);
      return true;
    }
    return false;
  }

  const trigger2 = document.querySelector(".redirect-pdp");
  if (trigger2) {
    trigger2.addEventListener("click", function () {
      const pdpLink = this.getAttribute("pdp-link");
      if (pdpLink) {
        window.location.href = pdpLink + "#reviews";
      }
    });
  }

  const trigger = document.querySelector("body.template-product .jdgm-widget.jdgm-preview-badge");
  if (trigger) {
    trigger.addEventListener("click", scrollToReviews);
  }

  if (window.location.hash === "#reviews") {
    if (!scrollToReviews()) {
      let attempts = 0;
      const maxAttempts = 20;

      const interval = setInterval(() => {
        if (scrollToReviews() || attempts > maxAttempts) {
          clearInterval(interval);
        }
        attempts++;
      }, 200);
    }
  }

  function syncEssentialBarClass() {
    const hasBar = document.querySelector('div.essential_annoucement_bar_wrapper');
    document.body.classList.toggle('with_essential_bar', !!hasBar);
    document.body.classList.toggle('without_essential_bar', !hasBar);
  }
  syncEssentialBarClass();
  new MutationObserver(syncEssentialBarClass).observe(document.body, { childList: true, subtree: true });

  safeSlickInit($(".announce-slick"), {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 2700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1800
  });

  function toggleHeaderClass() {
    if (document.body.classList.contains('template-page-lp24')) {
      return;
    }
    const header = document.querySelector('.header-wrapper');
    if (!header) return;

    if (window.scrollY > 54) {
      document.body.classList.add('header-sticky');
    } else {
      document.body.classList.remove('header-sticky');
    }
  }

  window.addEventListener('load', toggleHeaderClass);
  let headerScrollTick = false;
  window.addEventListener('scroll', () => {
    if (headerScrollTick) return;
    headerScrollTick = true;
    requestAnimationFrame(() => {
      toggleHeaderClass();
      headerScrollTick = false;
    });
  }, { passive: true });

  (function () {
    var rebuyAttempts = 0;
    var rebuyCheck = setInterval(function () {
      if (window.Rebuy && typeof window.Rebuy === 'object') {
        document.body.classList.add('rebuy-loaded');
        clearInterval(rebuyCheck);
      } else if (++rebuyAttempts >= 75) {
        clearInterval(rebuyCheck);
      }
    }, 200);
  })();

  // $(document).on('click', '.quantity__button', function () {
  //   if (!$('body').hasClass('template-cart')) return;

  //   var $button = $(this);
  //   var $quantityInput = $button.closest('.quantity').find('.quantity__input');
  //   var currentQty = parseInt($quantityInput.val(), 10);
  //   var lineIndex = $quantityInput.data('index');

  //   if ($button.attr('name') === 'plus') {
  //     currentQty = currentQty;
  //   } else if ($button.attr('name') === 'minus') {
  //     currentQty = Math.max(0, currentQty);
  //   }

  //   $('body').addClass('updating-cart');
  //   $(this).closest(".cart-item").addClass("update_cart_row");

  //   $quantityInput.val(currentQty);

  //   $.ajax({
  //     type: 'POST',
  //     url: '/cart/change.js',
  //     data: {
  //       line: lineIndex,
  //       quantity: currentQty
  //     },
  //     dataType: 'json',
  //     success: function () {
  //       console.log('cart updated');
  //       location.reload(true);
  //     },
  //     error: function (error) {
  //       console.error('Cart update failed:', error);
  //     }
  //   });
  // });

  $(document).on('click', '.quantity__button', function () {
    if (!$('body').hasClass('template-cart')) return;

    var $button = $(this);
    var $quantityInput = $button.closest('.quantity').find('.quantity__input');
    var currentQty = parseInt($quantityInput.val(), 10);
    var lineIndex = $quantityInput.data('index');

    // Calculate new quantity
    if ($button.attr('name') === 'plus') {
      currentQty = currentQty + 1;
    } else if ($button.attr('name') === 'minus') {
      currentQty = Math.max(0, currentQty - 1);
    }

    $('body').addClass('updating-cart');
    $button.closest(".cart-item").addClass("update_cart_row");
    $quantityInput.val(currentQty);

    // If quantity becomes 0, remove linked gift(s) too
    if (currentQty === 0) {
      $.getJSON('/cart.js', function(cart) {
        var updates = {};
        updates[lineIndex] = 0;
        cart.items.forEach(function(item, index) {
          if (item.properties && item.properties['_salepify-advanced-fg']) {
            updates[index + 1] = 0;
          }
        });
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {updates: updates},
          dataType: 'json',
          success: function () {
            location.reload(true);
            $('body').removeClass('updating-cart');
          },
          error: function (error) {
            console.error('Cart update failed:', error);
            $('body').removeClass('updating-cart');
          }
        });
      });
    } else {
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          line: lineIndex,
          quantity: currentQty
        },
        dataType: 'json',
        success: function () {
          location.reload(true);
        },
        error: function (error) {
          console.error('Cart update failed:', error);
        }
      });
    }
  });

  // for try once
  const productLinks = {
    // 30 servings (single_picker) — 3 options
    "30serv-so": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546730754263&quantity=1",
    "30serv-se": "https://www.alcamielements.com/cart/add?viewcart=true&id=47298927263959&quantity=1",
    "30serv-sm": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035602870487&quantity=1",
    "30serv-sc": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546730819799&quantity=1",

    // 60 servings (double_picker) — 9 combinations
    "60serv-do1-do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546782232791&quantity=1",
    "60serv-do1-dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605098711&quantity=1",
    "60serv-do1-dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546823258327&quantity=1",
    "60serv-dm1-do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605131479&quantity=1",
    "60serv-dm1-dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605197015&quantity=1",
    "60serv-dm1-dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605295319&quantity=1",
    "60serv-dc1-do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546782298327&quantity=1",
    "60serv-dc1-dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605393623&quantity=1",
    "60serv-dc1-dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546823389399&quantity=1",

    "60serv-de1-do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765659351&quantity=1",
    "60serv-do1-de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765561047&quantity=1",
    "60serv-de1-dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765692119&quantity=1",
    "60serv-dm1-de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765593815&quantity=1",
    "60serv-de1-dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765724887&quantity=1",
    "60serv-dc1-de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765626583&quantity=1",
    "60serv-de1-de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765757655&quantity=1",

    // 90 servings (triple_picker) — 64 combinations

  "90serv-to1-to2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316410583&quantity=1",
  "90serv-to1-to2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328174295&quantity=1",
  "90serv-to1-to2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328207063&quantity=1",
  "90serv-to1-to2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060122839&quantity=1",

  "90serv-to1-tm2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316443351&quantity=1",
  "90serv-to1-tm2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328239831&quantity=1",
  "90serv-to1-tm2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328272599&quantity=1",
  "90serv-to1-tm2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060155607&quantity=1",

  "90serv-to1-tc2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316476119&quantity=1",
  "90serv-to1-tc2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328305367&quantity=1",
  "90serv-to1-tc2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328338135&quantity=1",
  "90serv-to1-tc2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060188375&quantity=1",

  "90serv-to1-te2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060221143&quantity=1",
  "90serv-to1-te2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060253911&quantity=1",
  "90serv-to1-te2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060286679&quantity=1",
  "90serv-to1-te2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060319447&quantity=1",

  "90serv-tm1-to2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316508887&quantity=1",
  "90serv-tm1-to2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328370903&quantity=1",
  "90serv-tm1-to2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328403671&quantity=1",
  "90serv-tm1-to2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060352215&quantity=1",

  "90serv-tm1-tm2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316541655&quantity=1",
  "90serv-tm1-tm2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328436439&quantity=1",
  "90serv-tm1-tm2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328469207&quantity=1",
  "90serv-tm1-tm2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060384983&quantity=1",

  "90serv-tm1-tc2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316574423&quantity=1",
  "90serv-tm1-tc2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328501975&quantity=1",
  "90serv-tm1-tc2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328534743&quantity=1",
  "90serv-tm1-tc2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060417751&quantity=1",

  "90serv-tm1-te2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060450519&quantity=1",
  "90serv-tm1-te2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060483287&quantity=1",
  "90serv-tm1-te2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060516055&quantity=1",
  "90serv-tm1-te2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060548823&quantity=1",

  "90serv-tc1-to2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316607191&quantity=1",
  "90serv-tc1-to2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328567511&quantity=1",
  "90serv-tc1-to2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328600279&quantity=1",
  "90serv-tc1-to2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060581591&quantity=1",

  "90serv-tc1-tm2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316639959&quantity=1",
  "90serv-tc1-tm2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328633047&quantity=1",
  "90serv-tc1-tm2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328665815&quantity=1",
  "90serv-tc1-tm2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060614359&quantity=1",

  "90serv-tc1-tc2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316672727&quantity=1",
  "90serv-tc1-tc2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328698583&quantity=1",
  "90serv-tc1-tc2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328731351&quantity=1",
  "90serv-tc1-tc2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060647127&quantity=1",

  "90serv-tc1-te2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060679895&quantity=1",
  "90serv-tc1-te2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060712663&quantity=1",
  "90serv-tc1-te2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060745431&quantity=1",
  "90serv-tc1-te2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060778199&quantity=1",

  "90serv-te1-to2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060810967&quantity=1",
  "90serv-te1-to2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060843735&quantity=1",
  "90serv-te1-to2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060876503&quantity=1",
  "90serv-te1-to2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060909271&quantity=1",

  "90serv-te1-tm2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060942039&quantity=1",
  "90serv-te1-tm2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060974807&quantity=1",
  "90serv-te1-tm2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061007575&quantity=1",
  "90serv-te1-tm2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061040343&quantity=1",

  "90serv-te1-tc2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061073111&quantity=1",
  "90serv-te1-tc2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061105879&quantity=1",
  "90serv-te1-tc2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061138647&quantity=1",
  "90serv-te1-tc2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061171415&quantity=1",

  "90serv-te1-te2-to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061204183&quantity=1",
  "90serv-te1-te2-tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061236951&quantity=1",
  "90serv-te1-te2-tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061269719&quantity=1",
  "90serv-te1-te2-te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061302487&quantity=1"

  };
  // Subscription Links
  const subs_productLinks = {
    // 30 servings (single_picker) — 4 options
    "subs_30serv-subs_so": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546730754263&quantity=1&selling_plan=3474555095",
    "subs_30serv-subs_se": "https://www.alcamielements.com/cart/add?viewcart=true&id=47298927263959&quantity=1&selling_plan=3474555095",
    "subs_30serv-subs_sm": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035602870487&quantity=1&selling_plan=3474555095",
    "subs_30serv-subs_sc": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546730819799&quantity=1&selling_plan=3474555095",

    // 60 servings (double_picker) — 16 combinations
    "subs_60serv-subs_do1-subs_do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546782232791&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_do1-subs_dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605098711&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_do1-subs_dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546823258327&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dm1-subs_do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605131479&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dm1-subs_dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605197015&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dm1-subs_dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605295319&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dc1-subs_do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546782298327&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dc1-subs_dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=45035605393623&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dc1-subs_dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=44546823389399&quantity=1&selling_plan=3477962967",

    "subs_60serv-subs_de1-subs_do2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765659351&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_do1-subs_de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765561047&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_de1-subs_dm2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765692119&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dm1-subs_de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765593815&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_de1-subs_dc2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765724887&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_dc1-subs_de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765626583&quantity=1&selling_plan=3477962967",
    "subs_60serv-subs_de1-subs_de2": "https://www.alcamielements.com/cart/add?viewcart=true&id=47308765757655&quantity=1&selling_plan=3477962967",

    // 90 servings (triple_picker) — 64 combinations
  "subs_90serv-subs_to1-subs_to2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316410583&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_to2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328174295&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_to2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328207063&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_to2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060122839&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_to1-subs_tm2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316443351&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_tm2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328239831&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_tm2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328272599&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_tm2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060155607&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_to1-subs_tc2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316476119&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_tc2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328305367&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_tc2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328338135&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_tc2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060188375&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_to1-subs_te2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060221143&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_te2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060253911&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_te2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060286679&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_to1-subs_te2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060319447&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tm1-subs_to2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316508887&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_to2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328370903&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_to2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328403671&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_to2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060352215&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tm1-subs_tm2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316541655&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_tm2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328436439&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_tm2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328469207&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_tm2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060384983&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tm1-subs_tc2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316574423&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_tc2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328501975&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_tc2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328534743&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_tc2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060417751&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tm1-subs_te2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060450519&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_te2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060483287&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_te2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060516055&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tm1-subs_te2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060548823&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tc1-subs_to2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316607191&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_to2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328567511&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_to2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328600279&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_to2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060581591&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tc1-subs_tm2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316639959&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_tm2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328633047&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_tm2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328665815&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_tm2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060614359&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tc1-subs_tc2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367316672727&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_tc2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328698583&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_tc2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=46367328731351&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_tc2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060647127&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_tc1-subs_te2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060679895&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_te2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060712663&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_te2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060745431&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_tc1-subs_te2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060778199&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_te1-subs_to2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060810967&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_to2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060843735&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_to2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060876503&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_to2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060909271&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_te1-subs_tm2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060942039&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_tm2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305060974807&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_tm2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061007575&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_tm2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061040343&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_te1-subs_tc2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061073111&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_tc2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061105879&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_tc2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061138647&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_tc2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061171415&quantity=1&selling_plan=4635558103",

  "subs_90serv-subs_te1-subs_te2-subs_to3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061204183&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_te2-subs_tm3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061236951&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_te2-subs_tc3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061269719&quantity=1&selling_plan=4635558103",
  "subs_90serv-subs_te1-subs_te2-subs_te3": "https://www.alcamielements.com/cart/add?viewcart=true&id=47305061302487&quantity=1&selling_plan=4635558103"
    
  };

  // For different prices on different servings
  const servingPrices = {
    "30serv": "$1.3",
    "60serv": "$1.3",
    "90serv": "$1.3",
  };
  const giftValue = {
    "30serv": "($42 Value)",
    "60serv": "($84 Value)",
    "90serv": "($126 Value)",
  };
  const priceBlocks = {
    "30serv": document.getElementById("30serv_price"),
    "60serv": document.getElementById("60serv_price"),
    "90serv": document.getElementById("90serv_price"),
  };
  const top_priceBlocks = {
    "30serv": document.getElementById("try_30serv_price_top"),
    "60serv": document.getElementById("try_60serv_price_top"),
    "90serv": document.getElementById("try_90serv_price_top"),
  };

  const priceElement = document.getElementById("hero_current_price");
  const giftElement = document.getElementById("gift_value");

  function updateVisiblePriceBlock(selectedValue) {
    Object.values(priceBlocks).forEach((el) => {
      if (el) el.style.display = "none";
    });
    if (priceBlocks[selectedValue]) {
      priceBlocks[selectedValue].style.display = "flex";
    }
  }

  function update_topPriceBlock(selectedValue) {
    Object.values(top_priceBlocks).forEach((el) => {
      if (el) el.style.display = "none";
    });
    if (top_priceBlocks[selectedValue]) {
      top_priceBlocks[selectedValue].style.display = "flex";
    }
  }


  // for subscription
  // For different prices on different servings
  const subs_subscriptionNames = {
    subs_30serv: "Single Ritual",
    subs_60serv: "Double Ritual",
    subs_90serv: "Triple Ritual",
  };
  const subs_servingPrices = {
    subs_30serv: "$0.72<s>$1.03</s>",
    subs_60serv: "$0.58<s>$0.96</s>",
    subs_90serv: "$0.46<s>$0.91</s>",
  };
  const subs_giftValue = {
    subs_30serv: "$78",
    subs_60serv: "$156",
    subs_90serv: "$234",
  };
  const subs_discountValue = {
    subs_30serv: "30% Today",
    subs_60serv: "40% Today",
    subs_90serv: "50% Today",
  };
  const subs_bottlePrice = {
    subs_30serv: "$28",
    subs_60serv: "$56",
    subs_90serv: "$84",
  };
  const subs_frotherPrice = {
    subs_30serv: "$32",
    subs_60serv: "$64",
    subs_90serv: "$96",
  };
  const subs_spoonPrice = {
    subs_30serv: "$18",
    subs_60serv: "$36",
    subs_90serv: "$54",
  };
  const subs_priceBlocks = {
    subs_30serv: document.getElementById("subs_30serv_price"),
    subs_60serv: document.getElementById("subs_60serv_price"),
    subs_90serv: document.getElementById("subs_90serv_price"),
  };
  const subs_percupBlocks = {
    subs_30serv: document.getElementById("subs_30serv_cup"),
    subs_60serv: document.getElementById("subs_60serv_cup"),
    subs_90serv: document.getElementById("subs_90serv_cup"),
  };
  const top_subs_priceBlocks = {
    subs_30serv: document.getElementById("subs_30serv_price_top"),
    subs_60serv: document.getElementById("subs_60serv_price_top"),
    subs_90serv: document.getElementById("subs_90serv_price_top"),
  };
  const subs_try_buttonPrice = {
    subs_30serv: document.getElementById("try_button_price_single"),
    subs_60serv: document.getElementById("try_button_price_double"),
    subs_90serv: document.getElementById("try_button_price_triple"),
  };

  const subs_subscriptionNameElement = document.getElementById("subs_hero_sub_heading");
  const subs_priceElement = document.getElementById("subs_hero_current_price");
  const subs_giftElement = document.getElementById("subs_gift_value");
  const subs_gold_bottle_Element = document.getElementById("gold_bottle_price");
  const subs_gold_frother_Element = document.getElementById("gold_frother_price");
  const subs_gold_spoon_Element = document.getElementById("gold_spoon_price");
  const subs_try_priceElement = document.getElementById("try_button_price");
  const discountElement = document.getElementById("discountElement");

  function subs_updateVisiblePriceBlock(subs_selectedValue) {
    Object.values(subs_priceBlocks).forEach((el) => {
      if (el) el.style.display = "none";
    });
    if (subs_priceBlocks[subs_selectedValue]) {
      subs_priceBlocks[subs_selectedValue].style.display = "flex";
    }

    Object.values(subs_percupBlocks).forEach((el) => {
      if (el) el.style.display = "none";
    });
    if (subs_percupBlocks[subs_selectedValue]) {
      subs_percupBlocks[subs_selectedValue].style.display = "flex";
    }
  }

  function subs_updateButtonPrice(subs_selectedValue) {
    Object.values(subs_try_buttonPrice).forEach((el) => {
      if (el) el.style.display = "none";
    });
    if (subs_try_buttonPrice[subs_selectedValue]) {
      subs_try_buttonPrice[subs_selectedValue].style.display = "inline-block";
    }
  }

  function subs_updateTopPriceBlock(subs_selectedValue) {
    Object.values(top_subs_priceBlocks).forEach((el) => {
      if (el) el.style.display = "none";
    });
    if (top_subs_priceBlocks[subs_selectedValue]) {
      top_subs_priceBlocks[subs_selectedValue].style.display = "flex";
    }
  }

  function subs_updateValuesOnChange() {
    const subs_selectedRadio = document.querySelector('input[name="subs_servings"]:checked');
    if (!subs_selectedRadio) return;

    const subs_selectedValue = subs_selectedRadio.value;

    // Update name
    if (subs_subscriptionNameElement && subs_subscriptionNames[subs_selectedValue]) {
      subs_subscriptionNameElement.innerText = subs_subscriptionNames[subs_selectedValue];
    }

    // Update price
    if (subs_priceElement && subs_servingPrices[subs_selectedValue]) {
      subs_priceElement.innerHTML = subs_servingPrices[subs_selectedValue];
    }

    // Update Discount
    if (discountElement && subs_discountValue[subs_selectedValue]) {
      discountElement.innerText = subs_discountValue[subs_selectedValue];
    }

    // Update gift text
    if (subs_giftElement && subs_giftValue[subs_selectedValue]) {
      subs_giftElement.innerText = subs_giftValue[subs_selectedValue];
    }

    // Update gold bottle price
    if (subs_gold_bottle_Element && subs_bottlePrice[subs_selectedValue]) {
      subs_gold_bottle_Element.innerText = subs_bottlePrice[subs_selectedValue];
    }

    // Update gold frother price
    if (subs_gold_frother_Element && subs_frotherPrice[subs_selectedValue]) {
      subs_gold_frother_Element.innerText = subs_frotherPrice[subs_selectedValue];
    }

    // Update gold spoon price
    if (subs_gold_spoon_Element && subs_spoonPrice[subs_selectedValue]) {
      subs_gold_spoon_Element.innerText = subs_spoonPrice[subs_selectedValue];
    }


    // Update try button price
    if (subs_try_priceElement && subs_try_buttonPrice[subs_selectedValue]) {
      subs_try_priceElement.innerText = subs_try_buttonPrice[subs_selectedValue];
    }

    subs_updateVisiblePriceBlock(subs_selectedValue);
    subs_updateButtonPrice(subs_selectedValue);
    subs_updateTopPriceBlock(subs_selectedValue);
  }
  document.querySelectorAll('input[name="subs_servings"]').forEach((radio) => {
    radio.addEventListener("change", subs_updateValuesOnChange);
  });
  window.addEventListener("DOMContentLoaded", subs_updateValuesOnChange);

  const counters = document.querySelectorAll(".clarity_counter_strip li h6");

  function startCounter(counter) {
    let finalValue = parseInt(counter.textContent);
    let currentValue = 0;
    let speed = Math.ceil(finalValue / 50);

    let interval = setInterval(() => {
      currentValue += speed;
      if (currentValue >= finalValue) {
        currentValue = finalValue;
        clearInterval(interval);
      }
      counter.textContent = currentValue + "%";
    }, 50);
  }

  function checkViewport() {
    counters.forEach((counter) => {
      const rect = counter.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom >= 0) {
        if (!counter.classList.contains("animated")) {
          counter.classList.add("animated");
          startCounter(counter);
        }
      }
    });
  }

  let counterScrollTick = false;
window.addEventListener("scroll", () => {
  if (counterScrollTick) return;
  counterScrollTick = true;
  requestAnimationFrame(() => {
    checkViewport();
    counterScrollTick = false;
  });
}, { passive: true });
  checkViewport();

  function handleToggle(triggerSelector, targetSelector) {
    const triggers = document.querySelectorAll(triggerSelector);
    const targets = document.querySelectorAll(targetSelector);

    triggers.forEach((trigger) => {
      trigger.addEventListener("change", () => {
        const targetId = trigger.dataset.target;
        targets.forEach((t) => t.classList.remove("active"));
        const targetEl = document.getElementById(targetId);
        if (targetEl) targetEl.classList.add("active");
      });
    });
  }

  handleToggle(".try_hero_serve_container input", ".try_hero_flavor_container");
  handleToggle(".subs_hero_serve_container input", ".subs_hero_flavor_container");

  const radios = document.querySelectorAll(".products-page .hero_sub_type input[type=radio]");
  const boxes = document.querySelectorAll(".hero_pick_box");

  function updateHeroBox() {
    boxes.forEach((box) => (box.style.display = "none"));

    radios.forEach((radio) => {
      if (radio.checked) {
        const box = radio.closest("label")?.nextElementSibling;
        if (box?.classList.contains("hero_pick_box")) {
          box.style.display = "flex";
        }
      }
    });
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", updateHeroBox);
  });

  updateHeroBox();

  function updateProductLink() {
    const servingInput = document.querySelector('.hero_flavor_container input[type="radio"]:checked');
    if (!servingInput) return;

    const servingValue = servingInput.value;
    const targetContainer = document.getElementById(servingInput.dataset.target);
    if (!targetContainer) return;

    const selectedFlavors = targetContainer.querySelectorAll('input[type="radio"]:checked');
    const key = [servingValue, ...[...selectedFlavors].map(i => i.value)].join("-");
    const link = productLinks[key];

    const btn1 = document.querySelector("#try_hero_try_button");
    const btn2 = document.querySelector(".s7_btn_row a");

    if (btn1) btn1.href = link || "#";
    if (btn2) btn2.href = link || "#";
  }

  document.querySelectorAll('.try_hero_serve_container input, .hero_flavor_container input')
    .forEach(input => input.addEventListener("change", updateProductLink));

  updateProductLink();

  function subs_updateProductLink() {
    const servingInput = document.querySelector('.subs_hero_serve_container input[type="radio"]:checked');
    if (!servingInput) return;

    const servingValue = servingInput.value;
    const targetContainer = document.getElementById(servingInput.dataset.target);
    if (!targetContainer) return;

    const selectedFlavors = targetContainer.querySelectorAll('input[type="radio"]:checked');
    const key = [servingValue, ...[...selectedFlavors].map(i => i.value)].join("-");
    const link = subs_productLinks[key];

    const btn1 = document.querySelector("#subs_hero_try_button");
    const btn2 = document.querySelector(".s7_btn_row a");

    if (btn1) btn1.href = link || "#";
    if (btn2) btn2.href = link || "#";
  }

  document.querySelectorAll('.subs_hero_serve_container input, .hero_flavor_container input').forEach(input => input.addEventListener("change", subs_updateProductLink));
  subs_updateProductLink();

  function updateValuesOnChange() {
    const selectedRadio = document.querySelector('input[name="servings"]:checked');
    if (!selectedRadio) return;
    const selectedValue = selectedRadio.value;

    if (priceElement && servingPrices[selectedValue]) {
      priceElement.innerText = servingPrices[selectedValue];
    }

    if (giftElement && giftValue[selectedValue]) {
      giftElement.innerText = giftValue[selectedValue];
    }

    updateVisiblePriceBlock(selectedValue);
    update_topPriceBlock(selectedValue);
  }

  document.querySelectorAll('input[name="servings"]').forEach(radio => radio.addEventListener("change", updateValuesOnChange));
  updateValuesOnChange();

});

function initIngredients(section) {
  const slider = section.querySelector('.ingredient-slider-ss');

  if (!slider) return;

  // stop double init (either engine)
  if (slider.classList.contains('swiper-initialized') || slider.classList.contains('ingredients-flickity')) return;

  // Swiper path: templates still loading the Swiper bundle (gated in theme.liquid)
  if (typeof Swiper !== 'undefined') {
    slider.classList.remove('preview');

    new Swiper(slider, {
      speed: 300,
      navigation: {
        nextEl: section.querySelector('.swiper-next-ingredient-ss'),
        prevEl: section.querySelector('.swiper-prev-ingredient-ss'),
      },
      scrollbar: {
        el: section.querySelector('.swiper-scroll-ingredient-ss'),
        draggable: true,
      },
      breakpoints: {
        320: {
          spaceBetween: parseInt(slider.dataset.gapMobile || 0),
          slidesPerView: parseFloat(slider.dataset.viewMobile || 1),
        },
        1024: {
          spaceBetween: parseInt(slider.dataset.gap || 0),
          slidesPerView: parseFloat(slider.dataset.view || 1),
        }
      }
    });
    return;
  }

  // Flickity path: cell widths come from the section CSS (.ingredients-flickity rules)
  if (typeof Flickity === 'undefined') return;

  const wrapper = slider.querySelector('.swiper-wrapper');
  if (!wrapper) return;

  slider.classList.add('ingredients-flickity');
  slider.classList.remove('preview');

  const flkty = new Flickity(wrapper, {
    accessibility: false,
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: false,
    draggable: true,
    percentPosition: true
  });

  // ----- equal-height cards (replicates the Swiper flex-stretch design) -----
  const cells = wrapper.querySelectorAll('.swiper-slide');
  function equalizeHeights() {
    let max = 0;
    cells.forEach(function (cell) {
      cell.style.removeProperty('height');
    });
    cells.forEach(function (cell) {
      if (cell.offsetHeight > max) max = cell.offsetHeight;
    });
    cells.forEach(function (cell) {
      cell.style.setProperty('height', max + 'px', 'important');
    });
    flkty.resize();
  }

  // ----- arrows (same .swiper-button-disabled styling the section already has) -----
  const prevBtn = section.querySelector('.swiper-prev-ingredient-ss');
  const nextBtn = section.querySelector('.swiper-next-ingredient-ss');
  function updateArrows() {
    const last = flkty.slides.length - 1;
    if (prevBtn) prevBtn.classList.toggle('swiper-button-disabled', flkty.selectedIndex <= 0);
    if (nextBtn) nextBtn.classList.toggle('swiper-button-disabled', flkty.selectedIndex >= last);
  }
  if (prevBtn) prevBtn.addEventListener('click', function (e) { e.preventDefault(); flkty.previous(); });
  if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); flkty.next(); });
  flkty.on('select', updateArrows);

  // ----- draggable scrollbar (replicates Swiper's scrollbar, same class names) -----
  const track = section.querySelector('.swiper-scroll-ingredient-ss');
  let setDragX = function () {};
  if (track) {
    const dragEl = document.createElement('div');
    dragEl.className = 'swiper-scrollbar-drag';
    track.appendChild(dragEl);

    function scrollableDistance() {
      const s = flkty.slides;
      return s.length > 1 ? s[s.length - 1].target - s[0].target : 0;
    }
    function updateDragSize() {
      const trackW = track.clientWidth;
      const total = flkty.slideableWidth || wrapper.scrollWidth || 1;
      const viewW = wrapper.clientWidth || slider.clientWidth || 1;
      let dragW = trackW * (viewW / total);
      dragW = Math.max(24, Math.min(dragW, trackW));
      dragEl.style.width = dragW + 'px';
    }
    setDragX = function (progress) {
      const p = Math.max(0, Math.min(1, progress));
      const usable = track.clientWidth - dragEl.offsetWidth;
      dragEl.style.transform = 'translateX(' + (p * usable) + 'px)';
    };
    flkty.on('scroll', function (progress) { setDragX(progress); });

    let scrollbarDragging = false;
    let grabX = 0;
    function fractionFromPointer(clientX) {
      const rect = track.getBoundingClientRect();
      const usable = rect.width - dragEl.offsetWidth;
      if (usable <= 0) return 0;
      return Math.max(0, Math.min(1, (clientX - rect.left - grabX) / usable));
    }
    function positionByFraction(f) {
      const s = flkty.slides;
      if (!s.length) return;
      const first = s[0].target;
      flkty.velocity = 0;
      flkty.x = -(first + f * scrollableDistance());
      flkty.positionSlider();
      setDragX(f);
    }
    track.addEventListener('pointerdown', function (e) {
      e.preventDefault();
      scrollbarDragging = true;
      const dragRect = dragEl.getBoundingClientRect();
      grabX = dragEl.contains(e.target) ? (e.clientX - dragRect.left) : dragEl.offsetWidth / 2;
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
      positionByFraction(fractionFromPointer(e.clientX));
    });
    track.addEventListener('pointermove', function (e) {
      if (scrollbarDragging) positionByFraction(fractionFromPointer(e.clientX));
    });
    function endScrollbarDrag() {
      if (!scrollbarDragging) return;
      scrollbarDragging = false;
      // snap to the nearest slide, matching Swiper's snapOnRelease behavior
      const pos = -flkty.x;
      let nearest = 0;
      let best = Infinity;
      flkty.slides.forEach(function (s, i) {
        const d = Math.abs(s.target - pos);
        if (d < best) { best = d; nearest = i; }
      });
      flkty.select(nearest);
    }
    track.addEventListener('pointerup', endScrollbarDrag);
    track.addEventListener('pointercancel', endScrollbarDrag);

    function refreshScrollbar() {
      updateDragSize();
      const sc = scrollableDistance();
      const first = flkty.slides.length ? flkty.slides[0].target : 0;
      const progress = sc > 0 ? (-flkty.x - first) / sc : 0;
      setDragX(progress);
    }
    refreshScrollbar();
    window.addEventListener('resize', function () { window.requestAnimationFrame(function () { equalizeHeights(); refreshScrollbar(); }); });
    window.addEventListener('load', function () { equalizeHeights(); refreshScrollbar(); });
  } else {
    window.addEventListener('resize', function () { window.requestAnimationFrame(equalizeHeights); });
    window.addEventListener('load', equalizeHeights);
  }

  equalizeHeights();
  updateArrows();
}

function loadIngredients() {
  document.querySelectorAll('.ingredients-section').forEach(section => initIngredients(section));
}

document.addEventListener('DOMContentLoaded', loadIngredients);

$(document).ready(function() {
  const tripleComboVariantMap = {
    "subs_to1|subs_to2|subs_to3": "46367316410583",
    "subs_to1|subs_to2|subs_tm3": "46367328174295",
    "subs_to1|subs_to2|subs_tc3": "46367328207063",
    "subs_to1|subs_to2|subs_te3": "47305060122839",

    "subs_to1|subs_tm2|subs_to3": "46367316443351",
    "subs_to1|subs_tm2|subs_tm3": "46367328239831",
    "subs_to1|subs_tm2|subs_tc3": "46367328272599",
    "subs_to1|subs_tm2|subs_te3": "47305060155607",

    "subs_to1|subs_tc2|subs_to3": "46367316476119",
    "subs_to1|subs_tc2|subs_tm3": "46367328305367",
    "subs_to1|subs_tc2|subs_tc3": "46367328338135",
    "subs_to1|subs_tc2|subs_te3": "47305060188375",

    "subs_to1|subs_te2|subs_to3": "47305060221143",
    "subs_to1|subs_te2|subs_tm3": "47305060253911",
    "subs_to1|subs_te2|subs_tc3": "47305060286679",
    "subs_to1|subs_te2|subs_te3": "47305060319447",

    "subs_tm1|subs_to2|subs_to3": "46367316508887",
    "subs_tm1|subs_to2|subs_tm3": "46367328370903",
    "subs_tm1|subs_to2|subs_tc3": "46367328403671",
    "subs_tm1|subs_to2|subs_te3": "47305060352215",

    "subs_tm1|subs_tm2|subs_to3": "46367316541655",
    "subs_tm1|subs_tm2|subs_tm3": "46367328436439",
    "subs_tm1|subs_tm2|subs_tc3": "46367328469207",
    "subs_tm1|subs_tm2|subs_te3": "47305060384983",

    "subs_tm1|subs_tc2|subs_to3": "46367316574423",
    "subs_tm1|subs_tc2|subs_tm3": "46367328501975",
    "subs_tm1|subs_tc2|subs_tc3": "46367328534743",
    "subs_tm1|subs_tc2|subs_te3": "47305060417751",

    "subs_tm1|subs_te2|subs_to3": "47305060450519",
    "subs_tm1|subs_te2|subs_tm3": "47305060483287",
    "subs_tm1|subs_te2|subs_tc3": "47305060516055",
    "subs_tm1|subs_te2|subs_te3": "47305060548823",

    "subs_tc1|subs_to2|subs_to3": "46367316607191",
    "subs_tc1|subs_to2|subs_tm3": "46367328567511",
    "subs_tc1|subs_to2|subs_tc3": "46367328600279",
    "subs_tc1|subs_to2|subs_te3": "47305060581591",

    "subs_tc1|subs_tm2|subs_to3": "46367316639959",
    "subs_tc1|subs_tm2|subs_tm3": "46367328633047",
    "subs_tc1|subs_tm2|subs_tc3": "46367328665815",
    "subs_tc1|subs_tm2|subs_te3": "47305060614359",

    "subs_tc1|subs_tc2|subs_to3": "46367316672727",
    "subs_tc1|subs_tc2|subs_tm3": "46367328698583",
    "subs_tc1|subs_tc2|subs_tc3": "46367328731351",
    "subs_tc1|subs_tc2|subs_te3": "47305060647127",

    "subs_tc1|subs_te2|subs_to3": "47305060679895",
    "subs_tc1|subs_te2|subs_tm3": "47305060712663",
    "subs_tc1|subs_te2|subs_tc3": "47305060745431",
    "subs_tc1|subs_te2|subs_te3": "47305060778199",

    "subs_te1|subs_to2|subs_to3": "47305060810967",
    "subs_te1|subs_to2|subs_tm3": "47305060843735",
    "subs_te1|subs_to2|subs_tc3": "47305060876503",
    "subs_te1|subs_to2|subs_te3": "47305060909271",

    "subs_te1|subs_tm2|subs_to3": "47305060942039",
    "subs_te1|subs_tm2|subs_tm3": "47305060974807",
    "subs_te1|subs_tm2|subs_tc3": "47305061007575",
    "subs_te1|subs_tm2|subs_te3": "47305061040343",

    "subs_te1|subs_tc2|subs_to3": "47305061073111",
    "subs_te1|subs_tc2|subs_tm3": "47305061105879",
    "subs_te1|subs_tc2|subs_tc3": "47305061138647",
    "subs_te1|subs_tc2|subs_te3": "47305061171415",

    "subs_te1|subs_te2|subs_to3": "47305061204183",
    "subs_te1|subs_te2|subs_tm3": "47305061236951",
    "subs_te1|subs_te2|subs_tc3": "47305061269719",
    "subs_te1|subs_te2|subs_te3": "47305061302487"
  };

  const comboVariantMap = {
    "subs_do1|subs_do2": "44546782232791",
    "subs_do1|subs_de2": "47308765561047",
    "subs_do1|subs_dm2": "45035605098711",
    "subs_do1|subs_dc2": "44546823258327",

    "subs_de1|subs_do2": "47308765659351",
    "subs_de1|subs_de2": "47308765757655",
    "subs_de1|subs_dm2": "47308765692119",
    "subs_de1|subs_dc2": "47308765724887",

    "subs_dm1|subs_do2": "45035605131479",
    "subs_dm1|subs_de2": "47308765593815",
    "subs_dm1|subs_dm2": "45035605197015",
    "subs_dm1|subs_dc2": "45035605295319",

    "subs_dc1|subs_do2": "44546782298327",
    "subs_dc1|subs_de2": "47308765626583",
    "subs_dc1|subs_dm2": "45035605393623",
    "subs_dc1|subs_dc2": "44546823389399"
  };

  var firstTab = $('.faq-tabs__nav li.active').data('tab');

  var firstFaq = $('#tab-' + firstTab).find('.acc__card').first();
  if (firstFaq.length) {
    $('.acc__panel').stop(true, true).slideUp();
    $('.acc__card').removeClass('active active_item');
    $('.acc__title').removeClass('active');

    firstFaq.addClass('active');
    firstFaq.find('.acc__panel').stop(true, true).slideDown();
    firstFaq.find(".acc__title").addClass("active");
  }

  $('.faq-tabs__nav li').on('click', function () {
    var tabId = $(this).data('tab');

    $('.faq-tabs__nav li').removeClass('active');
    $(this).addClass('active');

    $('.faq-tab').removeClass('active');
    $('#tab-' + tabId).addClass('active');
    $('.acc__panel').stop(true, true).slideUp();
    $('.acc__card').removeClass('active active_item');
    $('.acc__title').removeClass('active');

    var firstFaq = $('#tab-' + tabId).find('.acc__card').first();

    if (firstFaq.length) {
      firstFaq.addClass('active');
      firstFaq.addClass('active_item');
      firstFaq.find('.acc__panel').stop(true, true).slideDown();
      firstFaq.find(".acc__title").addClass("active");
    }
  });

  $('.tabbed-blog-m').each(function () {
    const $section = $(this);
    $section.find('.tabbed-blog__tab').on('click', function () {
      const tabId = $(this).data('tab');
      $section.find('.tabbed-blog__tab').removeClass('is-active');
      $(this).addClass('is-active');
      $section.find('.tabbed-blog__content').removeClass('is-active');
      $section.find('.tabbed-blog__content[data-content="' + tabId + '"]').addClass('is-active');
    });

  });

  // Affiliate Program FAQs
  $(".alcami-page-v2faq").on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.alcami-page-v2faq');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

  // FAQs
  $('.faqs-list').on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.faqs-list');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

  // PDP Accordions
  $('.elements-triple-v2-home').on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.elements-triple-v2-home');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

  // Default PDP Accordions
  $('.pdp-default-sec').on('click', '.acc__title', function (e) {
    var accCard = $(this).closest('.acc__card');
    var accContainer = $(this).closest('.pdp-default-sec');
    var accPanel = accCard.find('.acc__panel');
    var accTitle = $(this);
    var plusIcon = accTitle.find('.plus_icon');
    var minusIcon = accTitle.find('.minus_icon');

    if (accCard.hasClass('active_item')) {
      accCard.removeClass('active_item');
      accTitle.removeClass('active');
      accPanel.stop(true, true).slideUp();
      plusIcon.show();
      minusIcon.hide();
    } else {
      accContainer.find('.acc__card').not(accCard).each(function () {
        $(this).removeClass('active_item')
        .find('.acc__panel').stop(true, true).slideUp().end()
        .find('.acc__title').removeClass('active')
        .find('.plus_icon').show().end()
        .find('.minus_icon').hide();
      });

      accCard.addClass('active_item');
      accTitle.addClass('active');
      accPanel.stop(true, true).slideDown();
      plusIcon.hide();
      minusIcon.show();
    }
  });

    $(".hero_input_flavor_list label.30label").on("click",function(){
      var dataimg = $(this).attr("data-image");
      console.log("data-image: ",dataimg);

      var index = $('.main-gallery img').toArray().findIndex(function(img) {
        var imgSrc = $(img).attr("src");

        if (!imgSrc || !dataimg) return false;

        // Remove query parameters from both URLs
        var cleanImgSrc = imgSrc.split("?")[0];
        var cleanDataImg = dataimg.split("?")[0];

        return cleanImgSrc === cleanDataImg;
      });

      if (index !== -1) {
        $('.main-gallery').slick('slickGoTo', index);
      }

      var datvarID = $(this).attr("data-idd");
      if (!datvarID) return;

      var $btn = $(".try-once-btn.is-active");
      if (!$btn.length) return;

      var $btn2 = $(".single_hero_btn.is_active_hero");
      if (!$btn2.length) return;

      var url = new URL($btn.attr("href") || "/cart/add", window.location.origin);
      url.searchParams.set("id", datvarID);

      var url2 = new URL($btn2.attr("href") || "/cart/add", window.location.origin);
      url2.searchParams.set("id", datvarID);
     
      if (document.body.classList.contains("template-product")) {
        var pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set("variant", datvarID);
        window.history.replaceState({}, "", pageUrl.toString());
      }

      if (!url.searchParams.get("quantity")) {
        url.searchParams.set("quantity", "1");
      }
      if (!url2.searchParams.get("quantity")) {
        url2.searchParams.set("quantity", "1");
      }

      $btn.attr("href", url.toString());

      $btn2.attr("href", url2.toString());
    });

    $(".hero_input_flavor_list label.60label").on("click",function(){
      const flavour1 = $('input[name="subs_double-flavour1"]:checked').val();
      const flavour2 = $('input[name="subs_double-flavour2"]:checked').val();

      var dataimg = $(this).attr("data-image");

      var index = $('.main-gallery img').toArray().findIndex(function(img) {
        var imgSrc = $(img).attr("src");

        if (!imgSrc || !dataimg) return false;

        // Remove query parameters from both URLs
        var cleanImgSrc = imgSrc.split("?")[0];
        var cleanDataImg = dataimg.split("?")[0];

        return cleanImgSrc === cleanDataImg;
      });

      if (index !== -1) {
        $('.main-gallery').slick('slickGoTo', index);
      }

      if (!flavour1 || !flavour2) return;
      const comboKey = `${flavour1}|${flavour2}`;
      const variantId = comboVariantMap[comboKey];

      if (!variantId) return;

      const $btn = $(".try-once-btn.is-active");
      const $btn2 = $(".single_hero_btn.is_active_hero");
      
      if ($btn.length) {
        const url = new URL($btn.attr("href") || "/cart/add", window.location.origin);
        url.searchParams.set("id", variantId);
        url.searchParams.set("quantity", "1");
        $btn.attr("href", url.toString());

        if (document.body.classList.contains("template-product")) {
          var pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set("variant", variantId);
          window.history.replaceState({}, "", pageUrl.toString());
        }
      }

      if ($btn2.length) {
        const url2 = new URL($btn2.attr("href") || "/cart/add", window.location.origin);
        url2.searchParams.set("id", variantId);
        url2.searchParams.set("quantity", "1");
        $btn2.attr("href", url2.toString());
      }
    });

    $(".hero_input_flavor_list label.90label").on("click",function(){
      const flavour1 = $('input[name="subs_triple-flavour1"]:checked').val();
      const flavour2 = $('input[name="subs_triple-flavour2"]:checked').val();
      const flavour3 = $('input[name="subs_triple-flavour3"]:checked').val();

      const dataimg = $(this).attr("data-image");

      var index = $('.main-gallery img').toArray().findIndex(function (img) {
        var imgSrc = $(img).attr("src");

        if (!imgSrc || !dataimg) return false;

        // Remove query parameters from both URLs
        var cleanImgSrc = imgSrc.split("?")[0];
        var cleanDataImg = dataimg.split("?")[0];

        return cleanImgSrc === cleanDataImg;
      });

      if (index !== -1) {
        $('.main-gallery').slick('slickGoTo', index);
      }

      if (!flavour1 || !flavour2 || !flavour3) return;

      const comboKey = `${flavour1}|${flavour2}|${flavour3}`;
      const variantId = tripleComboVariantMap[comboKey];

      if (!variantId) return;

      const $btn = $(".try-once-btn.is-active");
      const $btn2 = $(".single_hero_btn.is_active_hero");

      if ($btn.length) {
        const url = new URL($btn.attr("href") || "/cart/add", window.location.origin);
        url.searchParams.set("id", variantId);
        url.searchParams.set("quantity", "1");

        if (document.body.classList.contains("template-product")) {
          var pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set("variant", variantId);
          window.history.replaceState({}, "", pageUrl.toString());
        }
        
        $btn.attr("href", url.toString());
      }

      if ($btn2.length) {
        const url2 = new URL($btn2.attr("href") || "/cart/add", window.location.origin);
        url2.searchParams.set("id", variantId);
        url2.searchParams.set("quantity", "1");
        
        $btn2.attr("href", url2.toString());
      }
    });

    let urlParams = new URLSearchParams(window.location.search);
    let variant = urlParams.get('variant');

    if(variant != null){

      if(variant == 44546730819799){
        $(".hero_input_flavor_list label").each(function(){
          var ln = $(this).attr("ln");
          
          if (ln == "Cacao") {
            $(this).children("input").prop("checked", true);
            setTimeout(() => {
              $(this).trigger("click");
            }, 300);
          }
        });
      }

      if(variant == 45035602870487){
        $(".hero_input_flavor_list label").each(function(){
          var ln = $(this).attr("ln");
          
          if (ln == "Matcha") {
            $(this).children("input").prop("checked", true);
            setTimeout(() => {
              $(this).trigger("click");
            }, 300);
          }
        });
      }

      if(variant == 47298927263959){
        $(".hero_input_flavor_list label").each(function(){
          var ln = $(this).attr("ln");
          
          if (ln == "Espresso") {
            $(this).children("input").prop("checked", true);
            setTimeout(() => {
              $(this).trigger("click");
            }, 300);
          }
        });
      }
    }

    function animateValue(el, start, end, duration, callback) {
      let startTime = null;

      function step(currentTime) {
          if (!startTime) startTime = currentTime;
          const progress = Math.min((currentTime - startTime) / duration, 1);
          el.textContent = Math.floor(progress * (end - start) + start).toLocaleString() + '%';

          if (progress < 1) {
            requestAnimationFrame(step);
          } else {
            if (callback) callback();
          }
      }

      requestAnimationFrame(step);
    }

    function isElementInViewport(el) {
      const rect = el.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }

    function startAnimating(num) {
      const target = +num.getAttribute('data-target');
      animateValue(num, 0, target, 5000);
    }

    function startHoverAnimation() {
      const numbers = document.querySelectorAll('.impact-number');

      numbers.forEach(num => {
        num.addEventListener('mouseenter', function() {
          numbers.forEach(t => {
            if (t !== num) {
              const targetValue = t.getAttribute('data-target');
              t.textContent = targetValue.toLocaleString() + '%';
            }
          });

          const targetValue = parseInt(num.getAttribute('data-target'), 10);
          animateValue(num, 0, targetValue, 5000);
        });

        num.addEventListener('mouseleave', function() {
          const targetValue = num.getAttribute('data-target');
          num.textContent = targetValue.toLocaleString() + '%';
        });
      });
    }

    // function onScroll() {
    //   const numbers = document.querySelectorAll('.impact-number');
    //   numbers.forEach(num => {
    //     if (isElementInViewport(num) && !num.classList.contains('animated')) {
    //       num.classList.add('animated');
    //     }
    //   });
    // }

    window.onload = startHoverAnimation;
    // document.addEventListener('scroll', onScroll);
    // onScroll();

    (function () {
      const searchModal = document.querySelector('.header__right .search-modal');
      if (!searchModal) return;

      const isDesktop = window.matchMedia('(min-width: 990px)').matches;

      searchModal.addEventListener('click', function (event) {
        const overlay = event.target.closest('.modal-overlay');
        if (!overlay) return;

        const details = overlay.closest('details');
        if (details?.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });

      if (isDesktop) return;

      document.addEventListener('touchstart', function (e) {
        const details = searchModal.querySelector('details[open]');
        if (!details) return;
        const input = details.querySelector('.search__input');
        const predictive = details.querySelector('.predictive-search');
        if (input?.contains(e.target) || predictive?.contains(e.target)) {
          return;
        }

        e.preventDefault();
        details.removeAttribute('open');
      },
      { passive: false });
    })();

    $(document).on('click', '.header__right .search-modal button.close-search-modal', function (e) {
      e.preventDefault();
      $(this).closest('.header__right').find('search-modal details[open]').removeAttr('open');
    });

});

(async function () {

  const section3 = document.querySelector(".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver");
  if (!section3) return;

  $('.alcami-leaders-list').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick"
      }
    ]
  });

  $('.balanced-day-list').slick({
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    infinite: true,
    responsive: [
      {
        breakpoint: 767,
        settings: "unslick"
      }
    ]
  });

  $('.unique-perks-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: 'linear',
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-thumbnail-gallery').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      { breakpoint: 767, settings: { slidesToShow: 3 } }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-thumbnail-gallery',
    focusOnSelect: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: true,
          adaptiveHeight: true
        }
      }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-thumbnail-gallery').on('click', 'img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery').slick('slickGoTo', index);
  });

  const teaItems = section3.querySelectorAll(".new-layout-tea-item");
  if (!teaItems.length) return;

  const atcBtn3 = section3.querySelector("#kit_hero_try_button");
  const otpBtn3 = section3.querySelector("#otp_hero_link");
  const summaryContainer = section3.querySelector("[data-summary]");

  teaItems.forEach(el => el.classList.remove("active-tea-item"));
  let activeItem = teaItems[0];
  activeItem.classList.add("active-tea-item");

  function setActiveItem(item) {
    teaItems.forEach(el => el.classList.remove("active-tea-item"));
    item.classList.add("active-tea-item");
    activeItem = item;
  }

  function isActive(item) {
    return item.classList.contains("active-tea-item");
  }

  teaItems.forEach(item => {
    const input = item.querySelector(".new-tea-qty");
  if (!input) return;
  
  // Set first item default to 1
  if (item === teaItems[0]) {
    input.value = 1;
    input.dataset.lastValidValue = 1;
  } else {
    input.value = 0;
    input.dataset.lastValidValue = 0;
  }
  updateTeaSummary();
    item.addEventListener("click", function (e) {
      if (
        e.target.classList.contains("plus-tea") ||
        e.target.classList.contains("minus-tea") ||
        e.target.classList.contains("new-tea-qty")
      ) return;
      setActiveItem(this);

      const targetImg = this.dataset.img;
      if (!targetImg) return;
      const $gallery = $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.desktop-ver .kit-gallery');
      let slideIndex = -1;

      $gallery.find('.slick-slide').each(function () {
        const imgEl = $(this).find('img').first();
        const imgSrc = imgEl.attr('src');
        if (imgSrc && imgSrc.startsWith(targetImg)) {
          slideIndex = $(this).data('slick-index');
          return false;
        }
      });

      if (slideIndex >= 0) {
        $gallery.slick('slickGoTo', slideIndex);
      }

    });
  });

  function updateTeaSummary() {
    const selectionBox = section3.querySelector(".new-tea-your-selection");
    const selectedItemsEl = section3.querySelector(".new-tea-selected-items");
    const totalEl = section3.querySelector(".new-tea-total-value");

    if (!summaryContainer || !selectionBox) return;

    const items = section3.querySelectorAll(".new-layout-tea-item");
    const data = [];
    let total = 0;

    items.forEach(item => {
      const qtyInput = item.querySelector(".new-tea-qty");
      const idInput = item.querySelector(".new-tea-pdp-id");
      const subInput = item.querySelector(".new-tea-subscription");
      const title = item.querySelector("h3")?.innerText || "";
      const qty = parseInt(qtyInput.value || 0);
      const id = idInput?.value;

      if (qty > 0) {
        let price = 0;
        if (subInput?.dataset.subscriptionPrice) {
          const rawPrice = subInput.dataset.subscriptionPrice;
          const cents = parseInt(rawPrice.replace(/[^\d]/g, ""), 10) || 0;
          price = cents / 100;
        }
        const itemTotal = price * qty;
        total += itemTotal;

        data.push({id, qty, title, price, itemTotal,
          selling_plan_id: subInput?.dataset.sellingPlanId || null,
          subscription_interval: subInput?.dataset.subscriptionInterval || null
        });
      }
    });

    summaryContainer.dataset.summary = JSON.stringify(data);
    summaryContainer._summary = data;
    const hasDecimals = total % 1 !== 0;
    const formattedTotal = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: Shopify.currency.active,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    }).format(total);

    if (data.length > 0) {
      atcBtn3?.classList.remove("disabled");
      otpBtn3?.classList.remove("disabled");
      if (atcBtn3) atcBtn3.textContent = `Start Ritual • ${formattedTotal}`;
    } else {
      atcBtn3?.classList.add("disabled");
      otpBtn3?.classList.add("disabled");
      if (atcBtn3) atcBtn3.textContent = "Start Ritual";
    }

    if (data.length > 0) {
      selectionBox.style.display = "block";
      selectedItemsEl.innerHTML = data.map(item => `
        <div class="selected-row">
          <span>${item.qty} × ${item.title}</span>
        </div>
      `).join("");
      totalEl.textContent = formattedTotal;
    } else {
      selectionBox.style.display = "none";
      selectedItemsEl.innerHTML = "";
      totalEl.textContent = "";
    }
  }

  section3.querySelectorAll(".plus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = parseInt(input.value || 0) + 1;
      input.dataset.lastValidValue = input.value;
      updateTeaSummary();
    });
  });

  section3.querySelectorAll(".minus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = Math.max(0, parseInt(input.value || 0) - 1);
      input.dataset.lastValidValue = input.value;
      updateTeaSummary();
    });
  });

  section3.querySelectorAll(".new-tea-qty").forEach(input => {
    input.dataset.lastValidValue = input.value || 0;
    input.addEventListener("input", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive(item)) {
        this.value = this.dataset.lastValidValue || this.value;
        return;
      }
      if (this.value === "" || parseInt(this.value) < 0) this.value = 0;
      this.dataset.lastValidValue = this.value;
      updateTeaSummary();
    });
  });

  async function addToCart(isSubscription = false) {
    if (!summaryContainer?._summary || summaryContainer._summary.length === 0) return;

    const items = summaryContainer._summary.map(item => {
      const payload = {
        id: Number(item.id),
        quantity: Number(item.qty)
      };
      if (isSubscription && item.selling_plan_id) {
        payload.selling_plan = Number(item.selling_plan_id);
      }
      return payload;
    });

    if (!items.length) return;

    const btn = isSubscription ? atcBtn3 : otpBtn3;
    btn?.classList.add("loading");
    document.body.classList.add("updating-cart");
    section3.querySelector(".alcami-kit-v3-inn")?.classList.add("update_cart_row");

    openCartDrawers();
    setDrawerLoading(true, "Brewing your ritual");

    try {
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(Object.assign({ items: computeGiftItems(items).concat(items) }, CART_SECTIONS_PAYLOAD))
      });

      if (!addResponse.ok) throw new Error("Failed to add items");
      const addData = await addResponse.json();
      const kitSectionHTML = sectionFromResponse(addData);

      if (kitSectionHTML) {
        await applyMiniCart(null, kitSectionHTML);
        fetch("/cart.js").then((r) => r.json()).then((cart) => {
          renderCartBubbles(cart);
          reconcileGifts(cart);
        }).catch(() => {});
      } else {
        await refreshMiniCart({ openDrawer: true });
      }
    } catch (err) {
      console.error("Cart update error:", err);
    } finally {
      btn?.classList.remove("loading");
      document.body.classList.remove("updating-cart");
      section3.querySelector(".alcami-kit-v3-inn")?.classList.remove("update_cart_row");
    }
  }

  atcBtn3?.addEventListener("click", e => {
    e.preventDefault();
    addToCart(true);
  });

  otpBtn3?.addEventListener("click", e => {
    e.preventDefault();
    addToCart(false);
  });

})();

(async function () {

  const section4 = document.querySelector(".alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver");
  if (!section4) return;

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-thumbnail-gallery').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery',
    dots: false,
    arrows: false,
    infinite: false,
    responsive: [
      { breakpoint: 767, settings: { slidesToShow: 3 } }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    nextArrow: '<div class="next_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    prevArrow: '<div class="prev_arrow_slick alcami-gallery-slick"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_243_306)"><path d="M11.7406 15.8719C11.875 15.8719 12.0125 15.8188 12.1156 15.7156C12.3219 15.5094 12.3219 15.1719 12.1156 14.9656L5.05627 7.90626L12.0125 0.950012C12.2188 0.743762 12.2188 0.406262 12.0125 0.200012C11.8063 -0.00623798 11.4688 -0.00623798 11.2625 0.200012L3.92814 7.53126C3.72189 7.73751 3.72189 8.07501 3.92814 8.28126L11.3625 15.7156C11.4688 15.8219 11.6031 15.8719 11.7406 15.8719Z" fill="black"/></g><defs><clipPath id="clip0_243_306"><rect width="16" height="16" fill="white" transform="matrix(0 -1 1 0 0 16)"/></clipPath></defs></svg></div>',
    asNavFor: '.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-thumbnail-gallery',
    focusOnSelect: true,
    adaptiveHeight: true,
    infinite: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          dots: false,
          adaptiveHeight: true
        }
      }
    ]
  });

  $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-thumbnail-gallery').on('click', 'img', function (ev) {
    var index = $(this).closest('.slick-slide').data('slick-index');
    $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery').slick('slickGoTo', index);
  });

  const teaItems2 = section4.querySelectorAll(".new-layout-tea-item");
  if (!teaItems2.length) return;

  const atcBtn4 = section4.querySelector("#kit_hero_try_button");
  const otpBtn4 = section4.querySelector("#otp_hero_link");
  const summaryContainer2 = section4.querySelector("[data-summary]");

  teaItems2.forEach(el => el.classList.remove("active-tea-item"));
  let activeItem2 = teaItems2[0];
  activeItem2.classList.add("active-tea-item");

  function setActiveItem2(item) {
    teaItems2.forEach(el => el.classList.remove("active-tea-item"));
    item.classList.add("active-tea-item");
    activeItem2 = item;
  }

  function isActive2(item) {
    return item.classList.contains("active-tea-item");
  }

  teaItems2.forEach(item => {
    const input = item.querySelector(".new-tea-qty");
  if (!input) return;
  
  // Set first item default to 1
  if (item === teaItems2[0]) {
    input.value = 1;
    input.dataset.lastValidValue = 1;
  } else {
    input.value = 0;
    input.dataset.lastValidValue = 0;
  }
  updateTeaSummary2();
    item.addEventListener("click", function (e) {
      if (
        e.target.classList.contains("plus-tea") ||
        e.target.classList.contains("minus-tea") ||
        e.target.classList.contains("new-tea-qty")
      ) return;
      setActiveItem2(this);

      const targetImg = this.dataset.img;
      if (!targetImg) return;
      const $gallery = $('.alcami-kit-v3-sec.alcami-ritual-tea-sec.ritual-tea-new-layout.mobile-ver .kit-gallery');
      let slideIndex = -1;

      $gallery.find('.slick-slide:not(.slick-cloned)').each(function () {
        const imgSrc = $(this).find('img').attr('src');

        if (imgSrc && imgSrc.indexOf(targetImg) === 0) {
          slideIndex = Number($(this).attr('data-slick-index'));
          return false;
        }
      });

      if (slideIndex >= 0) {
        $gallery.slick('slickGoTo', slideIndex);
      }
    });
  });

  function updateTeaSummary2() {
    const selectionBox2 = section4.querySelector(".new-tea-your-selection");
    const selectedItemsEl2 = section4.querySelector(".new-tea-selected-items");
    const totalEl2 = section4.querySelector(".new-tea-total-value");

    if (!summaryContainer2 || !selectionBox2) return;

    const items2 = section4.querySelectorAll(".new-layout-tea-item");
    const data2 = [];
    let total2 = 0;

    items2.forEach(item => {
      const qtyInput = item.querySelector(".new-tea-qty");
      const idInput = item.querySelector(".new-tea-pdp-id");
      const subInput = item.querySelector(".new-tea-subscription");
      const title = item.querySelector("h3")?.innerText || "";
      const qty = parseInt(qtyInput.value || 0);
      const id = idInput?.value;

      if (qty > 0) {
        let price = 0;

        if (subInput?.dataset.subscriptionPrice) {
          const rawPrice = subInput.dataset.subscriptionPrice;
          const cents = parseInt(rawPrice.replace(/[^\d]/g, ""), 10) || 0;
          price = cents / 100;
        }

        const itemTotal = price * qty;
        total2 += itemTotal;

        data2.push({id, qty, title, price, itemTotal,
          selling_plan_id: subInput?.dataset.sellingPlanId || null,
          subscription_interval: subInput?.dataset.subscriptionInterval || null
        });
      }
    });

    summaryContainer2.dataset.summary = JSON.stringify(data2);
    summaryContainer2._summary = data2;
    const hasDecimals2 = total2 % 1 !== 0;
    const formattedTotal = new Intl.NumberFormat(undefined, {
      style: "currency",
      currency: Shopify.currency.active,
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: hasDecimals2 ? 2 : 0,
      maximumFractionDigits: 2
    }).format(total2);

    if (data2.length > 0) {
      atcBtn4?.classList.remove("disabled");
      otpBtn4?.classList.remove("disabled");
      if (atcBtn4) atcBtn4.textContent = `Start Ritual • ${formattedTotal}`;
    } else {
      atcBtn4?.classList.add("disabled");
      otpBtn4?.classList.add("disabled");
      if (atcBtn4) atcBtn4.textContent = "Start Ritual";
    }

    if (data2.length > 0) {
      selectionBox2.style.display = "block";
      selectedItemsEl2.innerHTML = data2.map(item => `
        <div class="selected-row">
          <span>${item.qty} × ${item.title}</span>
        </div>
      `).join("");
      totalEl2.textContent = formattedTotal;
    } else {
      selectionBox2.style.display = "none";
      selectedItemsEl2.innerHTML = "";
      totalEl2.textContent = "";
    }
  }

  section4.querySelectorAll(".plus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive2(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = parseInt(input.value || 0) + 1;
      input.dataset.lastValidValue = input.value;
      updateTeaSummary2();
    });
  });

  section4.querySelectorAll(".minus-tea").forEach(btn => {
    btn.addEventListener("click", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive2(item)) return;
      const input = item.querySelector(".new-tea-qty");
      input.value = Math.max(0, parseInt(input.value || 0) - 1);
      input.dataset.lastValidValue = input.value;
      updateTeaSummary2();
    });
  });

  section4.querySelectorAll(".new-tea-qty").forEach(input => {
    input.dataset.lastValidValue = input.value || 0;
    input.addEventListener("input", function () {
      const item = this.closest(".new-layout-tea-item");
      if (!isActive2(item)) {
        this.value = this.dataset.lastValidValue || this.value;
        return;
      }
      if (this.value === "" || parseInt(this.value) < 0) this.value = 0;
      this.dataset.lastValidValue = this.value;
      updateTeaSummary2();
    });
  });

  async function addToCart2(isSubscription = false) {
    if (!summaryContainer2?._summary || summaryContainer2._summary.length === 0) return;

    const items = summaryContainer2._summary.map(item => {
      const payload = {
        id: Number(item.id),
        quantity: Number(item.qty)
      };
      if (isSubscription && item.selling_plan_id) {
        payload.selling_plan = Number(item.selling_plan_id);
      }
      return payload;
    });

    if (!items.length) return;

    const btn = isSubscription ? atcBtn4 : otpBtn4;
    btn?.classList.add("loading");
    document.body.classList.add("updating-cart");
    section4.querySelector(".alcami-kit-v3-inn")?.classList.add("update_cart_row");

    openCartDrawers();
    setDrawerLoading(true, "Brewing your ritual");

    try {
      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(Object.assign({ items: computeGiftItems(items).concat(items) }, CART_SECTIONS_PAYLOAD))
      });

      if (!addResponse.ok) throw new Error("Failed to add items");
      const addData = await addResponse.json();
      const kitSectionHTML = sectionFromResponse(addData);

      if (kitSectionHTML) {
        await applyMiniCart(null, kitSectionHTML);
        fetch("/cart.js").then((r) => r.json()).then((cart) => {
          renderCartBubbles(cart);
          reconcileGifts(cart);
        }).catch(() => {});
      } else {
        await refreshMiniCart({ openDrawer: true });
      }
    } catch (err) {
      console.error("Cart update error:", err);
    } finally {
      btn?.classList.remove("loading");
      document.body.classList.remove("updating-cart");
      section4.querySelector(".alcami-kit-v3-inn")?.classList.remove("update_cart_row");
    }
  }

  atcBtn4?.addEventListener("click", e => {
    e.preventDefault();
    addToCart2(true);
  });

  otpBtn4?.addEventListener("click", e => {
    e.preventDefault();
    addToCart2(false);
  });

})();